
export const applicationTranslations = {
    "tr": {
        "Back_To_Dashboard": "Anasayfaya geri dön",
        "Back_To_Products": "Ürünlere Geri Dön",
        "Profile_Settings": "Profil Ayarları",
        "GoTo_Product": "Ürüne git",
        "Start_Trial": "Denemeye Başlayın",
        "Learn": "Bilgi",
        "Reports": "Raporlar",
        "Status": "Durum",
        "Free_Simpra_Account": "Simpra hesabınızı ücretsiz kullanmaya başlayın",
        "Name": "Ad",
        "Surname": "Soyad",
        "Email": "E-posta",
        "Phone_Code": "Telefon Kodu",
        "Phone_Number": "Telefon Numarası",
        "Current_Password": "Mevcut Şifre",
        "New_Password": "Yeni Şifre",
        "Confirm_New_Password": "Yeni Şifreyi Doğrula",
        "Your_Account": "Hesabınızla işiniz bitti mi?",
        "Meet_Our_Products": "Diğer Simpra Ürünlerini Keşfedin",
        "Meet_Our_Products_Description": "İşletmenizin tüm ihtiyaçlarına cevap veren diğer çözümlerimizi deneyimleyin.",
        "New_Customer_Meet_Our_Products": "Simpra Ürünlerini Keşfedin",
        "New_Customer_Meet_Our_Products_Description": "İşletmenizin tüm ihtiyaçlarına cevap veren çözümlerimizi keşfedin ve farkı deneyimleyin.",
        "Sign_Out_From_Browser": "Bu tarayıcıdan çıkış yapın",
        "Welcome": "Merhaba",
        "Sign_Out": "Çıkış Yap",
        "My_Permissions": "İzinlerim",
        "Campaign_Notifications": "Kampanya Bildirimleri",
        "Campaign_Notifications_Question": "Tüm kampanyalardan ve bildirimlerden haberdar olmak istiyor musunuz?",
        "Email_Permission": "Evet, e-posta aracılığıyla haberdar olmak isterim.",
        "SMS_Permission": "Evet, SMS aracılığıyla haberdar olmak isterim.",
        "Phone_Permission": "Evet, aranarak haberdar olmak isterim.",
        "Close": "KAPAT",
        "POS_App_Only_Title": "Uygulamamızdan Devam Edin",
        "POS_App_Only_Message": "Simpra POS'u kullanabilmek için lütfen iOS, Android mobil uygulamalarımız ya da Windows, MacOS, Linux masaüstü uygulamalarımızdan devam ediniz.",
        "Product_Inactive_Message": "Bu ürüne erişiminiz şu anda aktif değil. Lütfen yöneticinizle görüşün.",
        "Chatbot_Button_Label": "SELAM!",
        "Recommended_For_Device": "Cihazınız için önerilen",
        "Other_Platforms": "Diğer platformlar",
        "Status_Operational": "Operasyonel",
        "Status_Degraded": "Kısmi kesinti",
        "Status_Down": "Kesinti",
        "Save": "KAYDET",
        "Your_Products": "Ürünleriniz",
        "Your_Product_Message": "İşletmenizin tüm ihtiyaçlarını karşılayacak çözümlerimiz.",
        "All_Other_Products": "Diğer Ürünlerimiz",
        "passwordRulesMessage": "Şifreniz şunları içermeli:",
        "passwordRules1": "En az 8 karakter olmalı",
        "passwordRules2": "En az 1 sayı içermeli",
        "passwordRules3": "En az 1 büyük harf içermeli",
        "passwordRules4": "En az 1 özel karakter içermeli",
        "Learn_More": "Daha fazla",
        "Verified": "DOĞRULANDI",
        "Not_Verified": "DOĞRULANMADI",
        "Change_My_Password": "Şifremi değiştir",
        "Change_My_Password_Content": "Şifrenizi değiştirmek için oturumunuzu kapatabilir ve giriş sayfasındaki “Şifremi unuttum” alanını kullanabilirsiniz" ,
        "Enter_Your_Surname": "Soyadınızı girin",
        "Enter_Your_Name": "Adınızı girin",
        "Enter_Your_Phone": "Telefon numaranızı girin",
        "Chatbot_Welcome_Text": "Merhaba {{username}}! Seçtiğin Simpra Ürünü hakkında bana herhangi bir şey sorabilirsin, ben de cevabı bulurum.",
        "Chatbot_First_Message": "Tabi, Bana bu Simpra ürünü ile ilgili sorunu sor.",
        "Chatbot_Ask_About_Products": "Bana ürünlerimiz hakkında soru sor.",
        "Chatbot_Chat_Rating_Question": "Simpra AI ile sohbetin nasıldı?",
        "Chatbot_End_Chat": "SONLANDIR",
        "Chatbot_Send": "GÖNDER",
        "Chatbot_Thank_You": "Teşekkürler",
        "Chatbot_Feedback_Text": "Simpra AI siz değerli müşterilerimizin geri bildirimlerini kendini geliştirmek için sürekli kullanıyor.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Hangi ürün hakkında sorunuz var?",
        "Chatbot_Hello": "SELAM",
        "Chatbot_Hello_Text": "Merhaba {{username}}. Ben Simpra AI",
        "Simpra_Reports": "Simpra Raporlar",
        "sliderText1": "Simpra Reservation ile tüm rezervasyonlarınızı zaman ve mekan sınırı olmadan tek bir yerde toplayın. Yönetim artık çok daha kolay!",
        "sliderText2": "Hareketli Ağırlıklı Ortalama Maliyet hesabıyla, değişken ekonomik koşullarda gerçek maliyetlerinizi anlık olarak görün ve karlılığınızı koruyun.",
        "sliderText3": "Operasyonlarınızı her yerde anlık takip ederek doğru satış stratejileri kurgulayın ve gelirlerinizi %15'e kadar artırın.",
        "sliderText4": "Menünüz her an güncel ve çevre dostu! Order & Pay etklentisi ile temassız sipariş ve ödeme kolaylığının tadını çıkarın.",        
        "sliderTextHeaderBadge1": "Son Verin!",
        "sliderTextHeaderBadge2": "Dinamik Maliyet Yönetimi",
        "sliderTextHeaderBadge3": "Telefonunuzdan Öğrenin!",
        "sliderTextHeaderBadge4": "Bedelsiz!",
        "sliderTextHeader1": "No Show Endişesine",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Restoranınızın Durumunu",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "BİLGİ AL",
        "UiKit_Fill_Min_Length_Field_Label": "Bu alan en az {{minLength}} karakter olmalıdır.",
        "UiKit_Fill_Out_Field_Label": "Bu alan doldurulmalıdır.",
        "Support": "Destek",
        "Support_WhatsApp_Text": "WhatsApp Canlı Destek Hattı üzerinden iletişime geçebilirsiniz:",
        "Support_WhatsApp_Button": "WhatsApp Destek Hattı"
    },
    "en": {
        "Back_To_Dashboard": "Back to dashboard",
        "Back_To_Products": "Back To Products",
        "Profile_Settings": "Profile Settings",
        "GoTo_Product": "Go to product",
        "Start_Trial": "Start Trial",
        "Learn": "Learn",
        "Reports": "Reports",
        "Status": "Status",
        "Free_Simpra_Account": "Let's get started with your Simpra account free",
        "Name": "Name",
        "Surname": "Surname",
        "Email": "Email",
        "Phone_Code": "Phone Code",
        "Phone_Number": "Phone Number",
        "Current_Password": "Current Password",
        "New_Password": "New Password",
        "Confirm_New_Password": "Confirm New Password",
        "Your_Account": "Are you done with your account?",
        "Meet_Our_Products": "Experience Other Simpra Products",
        "Meet_Our_Products_Description": "Discover more solutions tailored to meet all your business needs.",
        "New_Customer_Meet_Our_Products": "Experience Simpra Products",
        "New_Customer_Meet_Our_Products_Description": "Discover our solutions designed to meet all your business needs and experience the difference.",
        "Sign_Out_From_Browser": "Sign out from this browser",
        "Welcome": "Welcome",
        "Sign_Out": "Logout",
        "My_Permissions": "My Permissions",
        "Campaign_Notifications": "Campaign Notifications",
        "Campaign_Notifications_Question": "Do you want to be informed about all campaigns and notifications?",
        "Email_Permission": "Yes, I would like to be notified via email.",
        "SMS_Permission": "Yes, I would like to be informed via SMS.",
        "Phone_Permission": "Yes, I would like to be notified by calling.",
        "Close": "CLOSE",
        "POS_App_Only_Title": "Continue From Our App",
        "POS_App_Only_Message": "To use Simpra POS, please continue from our iOS, Android mobile apps or our Windows, MacOS, Linux desktop apps.",
        "Product_Inactive_Message": "Your access to this product is currently inactive. Please contact your administrator.",
        "Chatbot_Button_Label": "HI!",
        "Recommended_For_Device": "Recommended for your device",
        "Other_Platforms": "Other platforms",
        "Status_Operational": "Operational",
        "Status_Degraded": "Partial outage",
        "Status_Down": "Down",
        "Save": "SAVE",
        "Your_Products": "Your Products",
        "Your_Product_Message": "Solutions designed to meet all your business needs.",
        "All_Other_Products": "All Other Products",
        "passwordRulesMessage": "Your password must contain:",
        "passwordRules1": "At least 8 characters",
        "passwordRules2": "At least 1 numeric",
        "passwordRules3": "At least 1 uppercase letter",
        "passwordRules4": "At least 1 special character",
        "Learn_More": "Learn more",
        "Verified": "VERIFIED",
        "Not_Verified": "NOT VERIFIED",
        "Change_My_Password": "Change my password",
        "Change_My_Password_Content": "To change your password, you can log out and use the “Forgot password” field on the login page.",
        "Enter_Your_Name": "Enter your name",
        "Enter_Your_Surname": "Enter your surname",
        "Enter_Your_Phone": "Enter your phone",
        "Chatbot_Welcome_Text": "Hello {{username}}! Ask me anything about the Simpra Product of your choice and I will find an answer.",
        "Chatbot_First_Message": "Sure, ask your question about the Simpra Inventory product.",
        "Chatbot_Ask_About_Products": "Ask me about our products.",
        "Chatbot_Chat_Rating_Question": "How is your conversation with Simpra AI?",
        "Chatbot_End_Chat": "END CHAT",
        "Chatbot_Send": "SEND",
        "Chatbot_Thank_You": "Thank you",
        "Chatbot_Feedback_Text": "Simpra AI is constantly working to improve the feedback of our valued customers.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Which product do you have a question about?",
        "Chatbot_Hello": "HELLO",
        "Chatbot_Hello_Text": "Hi {{username}}. I am Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "With Simpra Reservation, gather all your reservations in one place without any time or location limitations. Management is now much easier!",
        "sliderText2": "With the Moving Weighted Average Cost calculation, see your real costs in real-time in changing economic conditions and maintain your profitability.",
        "sliderText3": "Track your operations in real-time from anywhere, develop accurate sales strategies, and increase your revenue by up to 15%.",
        "sliderText4": "Your menu is always up-to-date and eco-friendly! Enjoy the convenience of contactless ordering and payment with the Order & Pay plugin.",    
        "sliderTextHeaderBadge1": "End It!",
        "sliderTextHeaderBadge2": "Dynamic Cost Management",
        "sliderTextHeaderBadge3": "Learn From Your Phone!",
        "sliderTextHeaderBadge4": "Free of Charge!",
        "sliderTextHeader1": "No Show Worry",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Your Restaurant's Status",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "LEARN MORE",
        "UiKit_Fill_Min_Length_Field_Label": "This field must be at least {{minLength}} characters.",
        "UiKit_Fill_Out_Field_Label": "This field must be filled.",
        "Support": "Support",
        "Support_WhatsApp_Text": "You can reach us via the WhatsApp Live Support Line:",
        "Support_WhatsApp_Button": "WhatsApp Support Line"
    },
    "de": {
        "Back_To_Dashboard": "Zurück zum Dashboard",
        "Back_To_Products": "Zurück zu den Produkten",
        "Profile_Settings": "Profileinstellungen",
        "GoTo_Product": "Zum Produkt",
        "Start_Trial": "Testphase starten",
        "Learn": "Lernen",
        "Reports": "Berichte",
        "Status": "Status",
        "Free_Simpra_Account": "Legen wir kostenlos mit Ihrem Simpra-Konto los",
        "Name": "Name",
        "Surname": "Nachname",
        "Email": "E-Mail",
        "Phone_Code": "Ländervorwahl",
        "Phone_Number": "Telefonnummer",
        "Current_Password": "Aktuelles Passwort",
        "New_Password": "Neues Passwort",
        "Confirm_New_Password": "Neues Passwort bestätigen",
        "Your_Account": "Sind Sie mit Ihrem Konto fertig?",
        "Meet_Our_Products": "Weitere Simpra-Produkte entdecken",
        "Meet_Our_Products_Description": "Entdecken Sie weitere Lösungen, die auf alle Anforderungen Ihres Unternehmens zugeschnitten sind.",
        "New_Customer_Meet_Our_Products": "Simpra-Produkte entdecken",
        "New_Customer_Meet_Our_Products_Description": "Entdecken Sie unsere Lösungen, die auf alle Anforderungen Ihres Unternehmens ausgelegt sind, und erleben Sie den Unterschied.",
        "Sign_Out_From_Browser": "Von diesem Browser abmelden",
        "Welcome": "Willkommen",
        "Sign_Out": "Abmelden",
        "My_Permissions": "Meine Berechtigungen",
        "Campaign_Notifications": "Kampagnenbenachrichtigungen",
        "Campaign_Notifications_Question": "Möchten Sie über alle Kampagnen und Benachrichtigungen informiert werden?",
        "Email_Permission": "Ja, ich möchte per E-Mail benachrichtigt werden.",
        "SMS_Permission": "Ja, ich möchte per SMS informiert werden.",
        "Phone_Permission": "Ja, ich möchte telefonisch benachrichtigt werden.",
        "Close": "SCHLIESSEN",
        "POS_App_Only_Title": "Weiter in unserer App",
        "POS_App_Only_Message": "Um Simpra POS zu nutzen, fahren Sie bitte in unseren iOS-, Android-Mobil-Apps oder unseren Windows-, MacOS-, Linux-Desktop-Apps fort.",
        "Product_Inactive_Message": "Ihr Zugang zu diesem Produkt ist derzeit inaktiv. Bitte wenden Sie sich an Ihren Administrator.",
        "Chatbot_Button_Label": "HALLO!",
        "Recommended_For_Device": "Empfohlen für Ihr Gerät",
        "Other_Platforms": "Andere Plattformen",
        "Status_Operational": "Betriebsbereit",
        "Status_Degraded": "Teilweiser Ausfall",
        "Status_Down": "Ausgefallen",
        "Save": "SPEICHERN",
        "Your_Products": "Ihre Produkte",
        "Your_Product_Message": "Lösungen, die auf alle Anforderungen Ihres Unternehmens ausgelegt sind.",
        "All_Other_Products": "Alle anderen Produkte",
        "passwordRulesMessage": "Ihr Passwort muss Folgendes enthalten:",
        "passwordRules1": "Mindestens 8 Zeichen",
        "passwordRules2": "Mindestens 1 Ziffer",
        "passwordRules3": "Mindestens 1 Großbuchstaben",
        "passwordRules4": "Mindestens 1 Sonderzeichen",
        "Learn_More": "Mehr erfahren",
        "Verified": "VERIFIZIERT",
        "Not_Verified": "NICHT VERIFIZIERT",
        "Change_My_Password": "Mein Passwort ändern",
        "Change_My_Password_Content": "Um Ihr Passwort zu ändern, können Sie sich abmelden und das Feld „Passwort vergessen“ auf der Anmeldeseite verwenden.",
        "Enter_Your_Name": "Geben Sie Ihren Namen ein",
        "Enter_Your_Surname": "Geben Sie Ihren Nachnamen ein",
        "Enter_Your_Phone": "Geben Sie Ihre Telefonnummer ein",
        "Chatbot_Welcome_Text": "Hallo {{username}}! Fragen Sie mich alles über das Simpra-Produkt Ihrer Wahl, und ich finde eine Antwort.",
        "Chatbot_First_Message": "Klar, stellen Sie Ihre Frage zum Produkt Simpra Inventory.",
        "Chatbot_Ask_About_Products": "Fragen Sie mich zu unseren Produkten.",
        "Chatbot_Chat_Rating_Question": "Wie verläuft Ihr Gespräch mit Simpra AI?",
        "Chatbot_End_Chat": "CHAT BEENDEN",
        "Chatbot_Send": "SENDEN",
        "Chatbot_Thank_You": "Danke",
        "Chatbot_Feedback_Text": "Simpra AI arbeitet ständig daran, das Feedback unserer geschätzten Kunden zu verbessern.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Zu welchem Produkt haben Sie eine Frage?",
        "Chatbot_Hello": "HALLO",
        "Chatbot_Hello_Text": "Hallo {{username}}. Ich bin Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Mit Simpra Reservation sammeln Sie alle Ihre Reservierungen ohne zeitliche oder örtliche Einschränkungen an einem Ort. Die Verwaltung ist jetzt viel einfacher!",
        "sliderText2": "Mit der Berechnung des gleitenden gewichteten Durchschnittspreises sehen Sie Ihre tatsächlichen Kosten in Echtzeit unter sich ändernden wirtschaftlichen Bedingungen und sichern Ihre Rentabilität.",
        "sliderText3": "Verfolgen Sie Ihre Abläufe in Echtzeit von überall, entwickeln Sie präzise Verkaufsstrategien und steigern Sie Ihren Umsatz um bis zu 15%.",
        "sliderText4": "Ihre Speisekarte ist immer aktuell und umweltfreundlich! Genießen Sie den Komfort von kontaktlosem Bestellen und Bezahlen mit dem Order & Pay Plugin.",
        "sliderTextHeaderBadge1": "Schluss damit!",
        "sliderTextHeaderBadge2": "Dynamisches Kostenmanagement",
        "sliderTextHeaderBadge3": "Lernen Sie von Ihrem Smartphone!",
        "sliderTextHeaderBadge4": "Kostenlos!",
        "sliderTextHeader1": "Keine No-Show-Sorgen",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Der Status Ihres Restaurants",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "MEHR ERFAHREN",
        "UiKit_Fill_Min_Length_Field_Label": "Dieses Feld muss mindestens {{minLength}} Zeichen enthalten.",
        "UiKit_Fill_Out_Field_Label": "Dieses Feld muss ausgefüllt werden.",
        "Support": "Support",
        "Support_WhatsApp_Text": "Sie können uns über die WhatsApp-Live-Support-Hotline erreichen:",
        "Support_WhatsApp_Button": "WhatsApp-Support-Hotline"
    },
    "fr": {
        "Back_To_Dashboard": "Retour au tableau de bord",
        "Back_To_Products": "Retour aux produits",
        "Profile_Settings": "Paramètres du profil",
        "GoTo_Product": "Accéder au produit",
        "Start_Trial": "Démarrer l'essai",
        "Learn": "Apprendre",
        "Reports": "Rapports",
        "Status": "Statut",
        "Free_Simpra_Account": "Commençons gratuitement avec votre compte Simpra",
        "Name": "Prénom",
        "Surname": "Nom",
        "Email": "E-mail",
        "Phone_Code": "Indicatif téléphonique",
        "Phone_Number": "Numéro de téléphone",
        "Current_Password": "Mot de passe actuel",
        "New_Password": "Nouveau mot de passe",
        "Confirm_New_Password": "Confirmer le nouveau mot de passe",
        "Your_Account": "Avez-vous terminé avec votre compte ?",
        "Meet_Our_Products": "Découvrez les autres produits Simpra",
        "Meet_Our_Products_Description": "Découvrez d'autres solutions conçues pour répondre à tous les besoins de votre entreprise.",
        "New_Customer_Meet_Our_Products": "Découvrez les produits Simpra",
        "New_Customer_Meet_Our_Products_Description": "Découvrez nos solutions conçues pour répondre à tous les besoins de votre entreprise et ressentez la différence.",
        "Sign_Out_From_Browser": "Se déconnecter de ce navigateur",
        "Welcome": "Bienvenue",
        "Sign_Out": "Déconnexion",
        "My_Permissions": "Mes autorisations",
        "Campaign_Notifications": "Notifications de campagnes",
        "Campaign_Notifications_Question": "Souhaitez-vous être informé de toutes les campagnes et notifications ?",
        "Email_Permission": "Oui, je souhaite être informé par e-mail.",
        "SMS_Permission": "Oui, je souhaite être informé par SMS.",
        "Phone_Permission": "Oui, je souhaite être informé par téléphone.",
        "Close": "FERMER",
        "POS_App_Only_Title": "Continuer depuis notre application",
        "POS_App_Only_Message": "Pour utiliser Simpra POS, veuillez continuer depuis nos applications mobiles iOS, Android ou nos applications de bureau Windows, MacOS, Linux.",
        "Product_Inactive_Message": "Votre accès à ce produit est actuellement inactif. Veuillez contacter votre administrateur.",
        "Chatbot_Button_Label": "SALUT !",
        "Recommended_For_Device": "Recommandé pour votre appareil",
        "Other_Platforms": "Autres plateformes",
        "Status_Operational": "Opérationnel",
        "Status_Degraded": "Panne partielle",
        "Status_Down": "Hors service",
        "Save": "ENREGISTRER",
        "Your_Products": "Vos produits",
        "Your_Product_Message": "Des solutions conçues pour répondre à tous les besoins de votre entreprise.",
        "All_Other_Products": "Tous les autres produits",
        "passwordRulesMessage": "Votre mot de passe doit contenir :",
        "passwordRules1": "Au moins 8 caractères",
        "passwordRules2": "Au moins 1 chiffre",
        "passwordRules3": "Au moins 1 lettre majuscule",
        "passwordRules4": "Au moins 1 caractère spécial",
        "Learn_More": "En savoir plus",
        "Verified": "VÉRIFIÉ",
        "Not_Verified": "NON VÉRIFIÉ",
        "Change_My_Password": "Changer mon mot de passe",
        "Change_My_Password_Content": "Pour changer votre mot de passe, vous pouvez vous déconnecter et utiliser le champ « Mot de passe oublié » sur la page de connexion.",
        "Enter_Your_Name": "Saisissez votre prénom",
        "Enter_Your_Surname": "Saisissez votre nom",
        "Enter_Your_Phone": "Saisissez votre numéro de téléphone",
        "Chatbot_Welcome_Text": "Bonjour {{username}} ! Posez-moi n'importe quelle question sur le produit Simpra de votre choix et je trouverai une réponse.",
        "Chatbot_First_Message": "Bien sûr, posez votre question sur le produit Simpra Inventory.",
        "Chatbot_Ask_About_Products": "Posez-moi des questions sur nos produits.",
        "Chatbot_Chat_Rating_Question": "Comment se passe votre conversation avec Simpra AI ?",
        "Chatbot_End_Chat": "TERMINER LA DISCUSSION",
        "Chatbot_Send": "ENVOYER",
        "Chatbot_Thank_You": "Merci",
        "Chatbot_Feedback_Text": "Simpra AI travaille constamment à améliorer les retours de nos précieux clients.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Sur quel produit portez-vous une question ?",
        "Chatbot_Hello": "BONJOUR",
        "Chatbot_Hello_Text": "Bonjour {{username}}. Je suis Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Avec Simpra Reservation, rassemblez toutes vos réservations au même endroit sans aucune limite de temps ni de lieu. La gestion est désormais beaucoup plus simple !",
        "sliderText2": "Grâce au calcul du coût moyen pondéré mobile, visualisez vos coûts réels en temps réel dans un contexte économique changeant et préservez votre rentabilité.",
        "sliderText3": "Suivez vos opérations en temps réel où que vous soyez, élaborez des stratégies de vente précises et augmentez votre chiffre d'affaires jusqu'à 15%.",
        "sliderText4": "Votre menu est toujours à jour et respectueux de l'environnement ! Profitez de la commande et du paiement sans contact avec le plugin Order & Pay.",
        "sliderTextHeaderBadge1": "Fini tout ça !",
        "sliderTextHeaderBadge2": "Gestion dynamique des coûts",
        "sliderTextHeaderBadge3": "Apprenez depuis votre téléphone !",
        "sliderTextHeaderBadge4": "Gratuit !",
        "sliderTextHeader1": "Fini l'inquiétude du no-show",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Le statut de votre restaurant",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "EN SAVOIR PLUS",
        "UiKit_Fill_Min_Length_Field_Label": "Ce champ doit comporter au moins {{minLength}} caractères.",
        "UiKit_Fill_Out_Field_Label": "Ce champ doit être rempli.",
        "Support": "Assistance",
        "Support_WhatsApp_Text": "Vous pouvez nous contacter via la ligne d'assistance en direct WhatsApp :",
        "Support_WhatsApp_Button": "Ligne d'assistance WhatsApp"
    },
    "ru": {
        "Back_To_Dashboard": "Назад к панели управления",
        "Back_To_Products": "Назад к продуктам",
        "Profile_Settings": "Настройки профиля",
        "GoTo_Product": "Перейти к продукту",
        "Start_Trial": "Начать пробный период",
        "Learn": "Обучение",
        "Reports": "Отчёты",
        "Status": "Статус",
        "Free_Simpra_Account": "Давайте начнём бесплатно с вашей учётной записи Simpra",
        "Name": "Имя",
        "Surname": "Фамилия",
        "Email": "Электронная почта",
        "Phone_Code": "Код страны",
        "Phone_Number": "Номер телефона",
        "Current_Password": "Текущий пароль",
        "New_Password": "Новый пароль",
        "Confirm_New_Password": "Подтвердите новый пароль",
        "Your_Account": "Вы закончили работу с учётной записью?",
        "Meet_Our_Products": "Познакомьтесь с другими продуктами Simpra",
        "Meet_Our_Products_Description": "Откройте для себя больше решений, созданных для всех потребностей вашего бизнеса.",
        "New_Customer_Meet_Our_Products": "Познакомьтесь с продуктами Simpra",
        "New_Customer_Meet_Our_Products_Description": "Откройте для себя наши решения, созданные для всех потребностей вашего бизнеса, и почувствуйте разницу.",
        "Sign_Out_From_Browser": "Выйти из этого браузера",
        "Welcome": "Добро пожаловать",
        "Sign_Out": "Выйти",
        "My_Permissions": "Мои разрешения",
        "Campaign_Notifications": "Уведомления о кампаниях",
        "Campaign_Notifications_Question": "Хотите получать информацию обо всех кампаниях и уведомлениях?",
        "Email_Permission": "Да, я хочу получать уведомления по электронной почте.",
        "SMS_Permission": "Да, я хочу получать информацию по SMS.",
        "Phone_Permission": "Да, я хочу получать уведомления по телефону.",
        "Close": "ЗАКРЫТЬ",
        "POS_App_Only_Title": "Продолжить в нашем приложении",
        "POS_App_Only_Message": "Чтобы использовать Simpra POS, пожалуйста, продолжите в наших мобильных приложениях для iOS, Android или в наших настольных приложениях для Windows, MacOS, Linux.",
        "Product_Inactive_Message": "Ваш доступ к этому продукту сейчас неактивен. Пожалуйста, обратитесь к администратору.",
        "Chatbot_Button_Label": "ПРИВЕТ!",
        "Recommended_For_Device": "Рекомендовано для вашего устройства",
        "Other_Platforms": "Другие платформы",
        "Status_Operational": "Работает",
        "Status_Degraded": "Частичный сбой",
        "Status_Down": "Не работает",
        "Save": "СОХРАНИТЬ",
        "Your_Products": "Ваши продукты",
        "Your_Product_Message": "Решения, созданные для всех потребностей вашего бизнеса.",
        "All_Other_Products": "Все другие продукты",
        "passwordRulesMessage": "Ваш пароль должен содержать:",
        "passwordRules1": "Не менее 8 символов",
        "passwordRules2": "Не менее 1 цифры",
        "passwordRules3": "Не менее 1 заглавной буквы",
        "passwordRules4": "Не менее 1 специального символа",
        "Learn_More": "Узнать больше",
        "Verified": "ПОДТВЕРЖДЕНО",
        "Not_Verified": "НЕ ПОДТВЕРЖДЕНО",
        "Change_My_Password": "Изменить мой пароль",
        "Change_My_Password_Content": "Чтобы изменить пароль, вы можете выйти из системы и воспользоваться полем «Забыли пароль» на странице входа.",
        "Enter_Your_Name": "Введите ваше имя",
        "Enter_Your_Surname": "Введите вашу фамилию",
        "Enter_Your_Phone": "Введите ваш номер телефона",
        "Chatbot_Welcome_Text": "Здравствуйте, {{username}}! Спросите меня о любом продукте Simpra на ваш выбор, и я найду ответ.",
        "Chatbot_First_Message": "Конечно, задайте свой вопрос о продукте Simpra Inventory.",
        "Chatbot_Ask_About_Products": "Спросите меня о наших продуктах.",
        "Chatbot_Chat_Rating_Question": "Как проходит ваш разговор с Simpra AI?",
        "Chatbot_End_Chat": "ЗАВЕРШИТЬ ЧАТ",
        "Chatbot_Send": "ОТПРАВИТЬ",
        "Chatbot_Thank_You": "Спасибо",
        "Chatbot_Feedback_Text": "Simpra AI постоянно работает над улучшением на основе отзывов наших ценных клиентов.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "О каком продукте у вас вопрос?",
        "Chatbot_Hello": "ЗДРАВСТВУЙТЕ",
        "Chatbot_Hello_Text": "Привет, {{username}}. Я Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "С Simpra Reservation собирайте все ваши бронирования в одном месте без ограничений по времени и местоположению. Управление теперь намного проще!",
        "sliderText2": "С расчётом скользящей средневзвешенной себестоимости видьте ваши реальные затраты в реальном времени в изменяющихся экономических условиях и сохраняйте свою прибыльность.",
        "sliderText3": "Отслеживайте свои операции в реальном времени из любого места, разрабатывайте точные стратегии продаж и увеличивайте доход до 15%.",
        "sliderText4": "Ваше меню всегда актуально и экологично! Наслаждайтесь удобством бесконтактного заказа и оплаты с плагином Order & Pay.",
        "sliderTextHeaderBadge1": "Покончите с этим!",
        "sliderTextHeaderBadge2": "Динамическое управление затратами",
        "sliderTextHeaderBadge3": "Учитесь с вашего телефона!",
        "sliderTextHeaderBadge4": "Бесплатно!",
        "sliderTextHeader1": "Никаких переживаний из-за неявок",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Статус вашего ресторана",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "УЗНАТЬ БОЛЬШЕ",
        "UiKit_Fill_Min_Length_Field_Label": "Это поле должно содержать не менее {{minLength}} символов.",
        "UiKit_Fill_Out_Field_Label": "Это поле должно быть заполнено.",
        "Support": "Поддержка",
        "Support_WhatsApp_Text": "Вы можете связаться с нами через линию живой поддержки WhatsApp:",
        "Support_WhatsApp_Button": "Линия поддержки WhatsApp"
    },
    "ar": {
        "Back_To_Dashboard": "العودة إلى لوحة التحكم",
        "Back_To_Products": "العودة إلى المنتجات",
        "Profile_Settings": "إعدادات الملف الشخصي",
        "GoTo_Product": "الانتقال إلى المنتج",
        "Start_Trial": "بدء التجربة",
        "Learn": "تعلّم",
        "Reports": "التقارير",
        "Status": "الحالة",
        "Free_Simpra_Account": "لنبدأ مجاناً مع حساب Simpra الخاص بك",
        "Name": "الاسم",
        "Surname": "اللقب",
        "Email": "البريد الإلكتروني",
        "Phone_Code": "رمز الهاتف",
        "Phone_Number": "رقم الهاتف",
        "Current_Password": "كلمة المرور الحالية",
        "New_Password": "كلمة المرور الجديدة",
        "Confirm_New_Password": "تأكيد كلمة المرور الجديدة",
        "Your_Account": "هل انتهيت من حسابك؟",
        "Meet_Our_Products": "جرّب منتجات Simpra الأخرى",
        "Meet_Our_Products_Description": "اكتشف المزيد من الحلول المصممة لتلبية جميع احتياجات عملك.",
        "New_Customer_Meet_Our_Products": "جرّب منتجات Simpra",
        "New_Customer_Meet_Our_Products_Description": "اكتشف حلولنا المصممة لتلبية جميع احتياجات عملك واختبر الفرق.",
        "Sign_Out_From_Browser": "تسجيل الخروج من هذا المتصفح",
        "Welcome": "مرحباً",
        "Sign_Out": "تسجيل الخروج",
        "My_Permissions": "أذوناتي",
        "Campaign_Notifications": "إشعارات الحملات",
        "Campaign_Notifications_Question": "هل تريد أن يتم إعلامك بجميع الحملات والإشعارات؟",
        "Email_Permission": "نعم، أود أن يتم إعلامي عبر البريد الإلكتروني.",
        "SMS_Permission": "نعم، أود أن يتم إعلامي عبر الرسائل النصية القصيرة.",
        "Phone_Permission": "نعم، أود أن يتم إعلامي عبر الاتصال الهاتفي.",
        "Close": "إغلاق",
        "POS_App_Only_Title": "تابع من تطبيقنا",
        "POS_App_Only_Message": "لاستخدام Simpra POS، يرجى المتابعة من تطبيقاتنا للهاتف المحمول على iOS وAndroid أو من تطبيقاتنا لسطح المكتب على Windows وMacOS وLinux.",
        "Product_Inactive_Message": "وصولك إلى هذا المنتج غير مُفعَّل حاليًا. يرجى التواصل مع المسؤول.",
        "Chatbot_Button_Label": "مرحبًا!",
        "Recommended_For_Device": "موصى به لجهازك",
        "Other_Platforms": "منصات أخرى",
        "Status_Operational": "يعمل بشكل طبيعي",
        "Status_Degraded": "انقطاع جزئي",
        "Status_Down": "متوقف",
        "Save": "حفظ",
        "Your_Products": "منتجاتك",
        "Your_Product_Message": "حلول مصممة لتلبية جميع احتياجات عملك.",
        "All_Other_Products": "جميع المنتجات الأخرى",
        "passwordRulesMessage": "يجب أن تحتوي كلمة المرور على:",
        "passwordRules1": "8 أحرف على الأقل",
        "passwordRules2": "رقم واحد على الأقل",
        "passwordRules3": "حرف كبير واحد على الأقل",
        "passwordRules4": "رمز خاص واحد على الأقل",
        "Learn_More": "اعرف المزيد",
        "Verified": "موثّق",
        "Not_Verified": "غير موثّق",
        "Change_My_Password": "تغيير كلمة المرور الخاصة بي",
        "Change_My_Password_Content": "لتغيير كلمة المرور، يمكنك تسجيل الخروج واستخدام حقل \"نسيت كلمة المرور\" في صفحة تسجيل الدخول.",
        "Enter_Your_Name": "أدخل اسمك",
        "Enter_Your_Surname": "أدخل لقبك",
        "Enter_Your_Phone": "أدخل رقم هاتفك",
        "Chatbot_Welcome_Text": "مرحباً {{username}}! اسألني عن أي شيء بخصوص منتج Simpra الذي تختاره وسأجد لك الإجابة.",
        "Chatbot_First_Message": "بالتأكيد، اطرح سؤالك حول منتج Simpra Inventory.",
        "Chatbot_Ask_About_Products": "اسألني عن منتجاتنا.",
        "Chatbot_Chat_Rating_Question": "كيف كانت محادثتك مع Simpra AI؟",
        "Chatbot_End_Chat": "إنهاء المحادثة",
        "Chatbot_Send": "إرسال",
        "Chatbot_Thank_You": "شكراً لك",
        "Chatbot_Feedback_Text": "يعمل Simpra AI باستمرار على تحسين ملاحظات عملائنا الكرام.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "أي منتج لديك سؤال بشأنه؟",
        "Chatbot_Hello": "مرحباً",
        "Chatbot_Hello_Text": "مرحباً {{username}}. أنا Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "مع Simpra Reservation، اجمع كل حجوزاتك في مكان واحد دون أي قيود زمنية أو مكانية. أصبحت الإدارة الآن أسهل بكثير!",
        "sliderText2": "مع حساب متوسط التكلفة المرجح المتحرك، شاهد تكاليفك الحقيقية في الوقت الفعلي في ظل الظروف الاقتصادية المتغيرة وحافظ على ربحيتك.",
        "sliderText3": "تابع عملياتك في الوقت الفعلي من أي مكان، وطوّر استراتيجيات مبيعات دقيقة، وزد إيراداتك بنسبة تصل إلى %15.",
        "sliderText4": "قائمتك محدّثة دائماً وصديقة للبيئة! استمتع بسهولة الطلب والدفع دون تلامس مع إضافة Order & Pay.",
        "sliderTextHeaderBadge1": "أنهِ ذلك!",
        "sliderTextHeaderBadge2": "إدارة التكاليف الديناميكية",
        "sliderTextHeaderBadge3": "تعلّم من هاتفك!",
        "sliderTextHeaderBadge4": "مجاناً!",
        "sliderTextHeader1": "لا قلق من عدم الحضور",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "حالة مطعمك",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "اعرف المزيد",
        "UiKit_Fill_Min_Length_Field_Label": "يجب أن يحتوي هذا الحقل على {{minLength}} حرفاً على الأقل.",
        "UiKit_Fill_Out_Field_Label": "يجب ملء هذا الحقل.",
        "Support": "الدعم",
        "Support_WhatsApp_Text": "يمكنك التواصل معنا عبر خط الدعم المباشر على واتساب:",
        "Support_WhatsApp_Button": "خط دعم واتساب"
    },
    "zh": {
        "Back_To_Dashboard": "返回仪表板",
        "Back_To_Products": "返回产品",
        "Profile_Settings": "个人资料设置",
        "GoTo_Product": "前往产品",
        "Start_Trial": "开始试用",
        "Learn": "学习",
        "Reports": "报告",
        "Status": "状态",
        "Free_Simpra_Account": "让我们免费开始使用您的 Simpra 账户",
        "Name": "名字",
        "Surname": "姓氏",
        "Email": "电子邮箱",
        "Phone_Code": "电话区号",
        "Phone_Number": "电话号码",
        "Current_Password": "当前密码",
        "New_Password": "新密码",
        "Confirm_New_Password": "确认新密码",
        "Your_Account": "您的账户设置完成了吗？",
        "Meet_Our_Products": "体验其他 Simpra 产品",
        "Meet_Our_Products_Description": "发现更多为满足您所有业务需求而量身定制的解决方案。",
        "New_Customer_Meet_Our_Products": "体验 Simpra 产品",
        "New_Customer_Meet_Our_Products_Description": "发现我们为满足您所有业务需求而设计的解决方案，感受不同之处。",
        "Sign_Out_From_Browser": "从此浏览器退出登录",
        "Welcome": "欢迎",
        "Sign_Out": "退出登录",
        "My_Permissions": "我的权限",
        "Campaign_Notifications": "活动通知",
        "Campaign_Notifications_Question": "您希望获知所有活动和通知吗？",
        "Email_Permission": "是的，我希望通过电子邮件接收通知。",
        "SMS_Permission": "是的，我希望通过短信接收通知。",
        "Phone_Permission": "是的，我希望通过电话接收通知。",
        "Close": "关闭",
        "POS_App_Only_Title": "从我们的应用继续",
        "POS_App_Only_Message": "要使用 Simpra POS，请从我们的 iOS、Android 移动应用或 Windows、MacOS、Linux 桌面应用继续。",
        "Product_Inactive_Message": "您对此产品的访问当前未启用。请联系您的管理员。",
        "Chatbot_Button_Label": "你好！",
        "Recommended_For_Device": "为您的设备推荐",
        "Other_Platforms": "其他平台",
        "Status_Operational": "运行正常",
        "Status_Degraded": "部分中断",
        "Status_Down": "已停机",
        "Save": "保存",
        "Your_Products": "您的产品",
        "Your_Product_Message": "为满足您所有业务需求而设计的解决方案。",
        "All_Other_Products": "所有其他产品",
        "passwordRulesMessage": "您的密码必须包含：",
        "passwordRules1": "至少 8 个字符",
        "passwordRules2": "至少 1 个数字",
        "passwordRules3": "至少 1 个大写字母",
        "passwordRules4": "至少 1 个特殊字符",
        "Learn_More": "了解更多",
        "Verified": "已验证",
        "Not_Verified": "未验证",
        "Change_My_Password": "修改我的密码",
        "Change_My_Password_Content": "要修改密码，您可以退出登录，并在登录页面使用“忘记密码”功能。",
        "Enter_Your_Name": "输入您的名字",
        "Enter_Your_Surname": "输入您的姓氏",
        "Enter_Your_Phone": "输入您的电话",
        "Chatbot_Welcome_Text": "您好 {{username}}！有任何关于您所选 Simpra 产品的问题都可以问我，我会为您找到答案。",
        "Chatbot_First_Message": "当然，请提出您关于 Simpra Inventory 产品的问题。",
        "Chatbot_Ask_About_Products": "向我咨询我们的产品。",
        "Chatbot_Chat_Rating_Question": "您与 Simpra AI 的对话体验如何？",
        "Chatbot_End_Chat": "结束对话",
        "Chatbot_Send": "发送",
        "Chatbot_Thank_You": "谢谢您",
        "Chatbot_Feedback_Text": "Simpra AI 正在不断努力改进我们尊贵客户的反馈。",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "您想咨询哪款产品？",
        "Chatbot_Hello": "您好",
        "Chatbot_Hello_Text": "您好 {{username}}。我是 Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "借助 Simpra Reservation，不受时间和地点限制，将您的所有预订集中在一处管理。现在管理变得更轻松了！",
        "sliderText2": "通过移动加权平均成本计算，在不断变化的经济环境中实时查看您的真实成本，保持您的盈利能力。",
        "sliderText3": "随时随地实时跟踪您的运营，制定精准的销售策略，将您的收入提升高达 %15。",
        "sliderText4": "您的菜单始终保持最新且环保！通过 Order & Pay 插件，享受无接触点餐和支付的便捷。",
        "sliderTextHeaderBadge1": "杜绝它！",
        "sliderTextHeaderBadge2": "动态成本管理",
        "sliderTextHeaderBadge3": "用手机学习！",
        "sliderTextHeaderBadge4": "免费！",
        "sliderTextHeader1": "不再担心爽约",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "您餐厅的状态",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "了解更多",
        "UiKit_Fill_Min_Length_Field_Label": "此字段至少需要 {{minLength}} 个字符。",
        "UiKit_Fill_Out_Field_Label": "此字段为必填项。",
        "Support": "支持",
        "Support_WhatsApp_Text": "您可以通过 WhatsApp 在线支持热线与我们联系：",
        "Support_WhatsApp_Button": "WhatsApp 支持热线"
    },
    "sv": {
        "Back_To_Dashboard": "Tillbaka till instrumentpanelen",
        "Back_To_Products": "Tillbaka till produkter",
        "Profile_Settings": "Profilinställningar",
        "GoTo_Product": "Gå till produkten",
        "Start_Trial": "Starta provperiod",
        "Learn": "Lär dig",
        "Reports": "Rapporter",
        "Status": "Status",
        "Free_Simpra_Account": "Låt oss komma igång med ditt Simpra-konto gratis",
        "Name": "Förnamn",
        "Surname": "Efternamn",
        "Email": "E-post",
        "Phone_Code": "Landsnummer",
        "Phone_Number": "Telefonnummer",
        "Current_Password": "Nuvarande lösenord",
        "New_Password": "Nytt lösenord",
        "Confirm_New_Password": "Bekräfta nytt lösenord",
        "Your_Account": "Är du klar med ditt konto?",
        "Meet_Our_Products": "Upplev andra Simpra-produkter",
        "Meet_Our_Products_Description": "Upptäck fler lösningar som är skräddarsydda för att möta alla dina affärsbehov.",
        "New_Customer_Meet_Our_Products": "Upplev Simpra-produkter",
        "New_Customer_Meet_Our_Products_Description": "Upptäck våra lösningar som är utformade för att möta alla dina affärsbehov och upplev skillnaden.",
        "Sign_Out_From_Browser": "Logga ut från den här webbläsaren",
        "Welcome": "Välkommen",
        "Sign_Out": "Logga ut",
        "My_Permissions": "Mina behörigheter",
        "Campaign_Notifications": "Kampanjnotiser",
        "Campaign_Notifications_Question": "Vill du bli informerad om alla kampanjer och notiser?",
        "Email_Permission": "Ja, jag vill bli notifierad via e-post.",
        "SMS_Permission": "Ja, jag vill bli informerad via SMS.",
        "Phone_Permission": "Ja, jag vill bli notifierad via telefonsamtal.",
        "Close": "STÄNG",
        "POS_App_Only_Title": "Fortsätt från vår app",
        "POS_App_Only_Message": "För att använda Simpra POS, fortsätt från våra mobilappar för iOS, Android eller våra skrivbordsappar för Windows, MacOS, Linux.",
        "Product_Inactive_Message": "Din åtkomst till den här produkten är för närvarande inaktiv. Kontakta din administratör.",
        "Chatbot_Button_Label": "HEJ!",
        "Recommended_For_Device": "Rekommenderas för din enhet",
        "Other_Platforms": "Andra plattformar",
        "Status_Operational": "I drift",
        "Status_Degraded": "Delvis avbrott",
        "Status_Down": "Nere",
        "Save": "SPARA",
        "Your_Products": "Dina produkter",
        "Your_Product_Message": "Lösningar utformade för att möta alla dina affärsbehov.",
        "All_Other_Products": "Alla andra produkter",
        "passwordRulesMessage": "Ditt lösenord måste innehålla:",
        "passwordRules1": "Minst 8 tecken",
        "passwordRules2": "Minst 1 siffra",
        "passwordRules3": "Minst 1 versal",
        "passwordRules4": "Minst 1 specialtecken",
        "Learn_More": "Läs mer",
        "Verified": "VERIFIERAD",
        "Not_Verified": "EJ VERIFIERAD",
        "Change_My_Password": "Ändra mitt lösenord",
        "Change_My_Password_Content": "För att ändra ditt lösenord kan du logga ut och använda fältet \"Glömt lösenord\" på inloggningssidan.",
        "Enter_Your_Name": "Ange ditt förnamn",
        "Enter_Your_Surname": "Ange ditt efternamn",
        "Enter_Your_Phone": "Ange ditt telefonnummer",
        "Chatbot_Welcome_Text": "Hej {{username}}! Fråga mig vad som helst om den Simpra-produkt du väljer så hittar jag ett svar.",
        "Chatbot_First_Message": "Visst, ställ din fråga om produkten Simpra Inventory.",
        "Chatbot_Ask_About_Products": "Fråga mig om våra produkter.",
        "Chatbot_Chat_Rating_Question": "Hur är din konversation med Simpra AI?",
        "Chatbot_End_Chat": "AVSLUTA CHATT",
        "Chatbot_Send": "SKICKA",
        "Chatbot_Thank_You": "Tack",
        "Chatbot_Feedback_Text": "Simpra AI arbetar ständigt med att förbättra återkopplingen från våra värdefulla kunder.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Vilken produkt har du en fråga om?",
        "Chatbot_Hello": "HEJ",
        "Chatbot_Hello_Text": "Hej {{username}}. Jag är Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Med Simpra Reservation samlar du alla dina bokningar på ett ställe utan några tids- eller platsbegränsningar. Hanteringen är nu mycket enklare!",
        "sliderText2": "Med beräkningen av glidande vägd genomsnittskostnad ser du dina verkliga kostnader i realtid under föränderliga ekonomiska förhållanden och behåller din lönsamhet.",
        "sliderText3": "Följ din verksamhet i realtid varifrån som helst, utveckla träffsäkra försäljningsstrategier och öka dina intäkter med upp till %15.",
        "sliderText4": "Din meny är alltid uppdaterad och miljövänlig! Njut av bekvämligheten med kontaktlös beställning och betalning med Order & Pay-plugin.",
        "sliderTextHeaderBadge1": "Få stopp på det!",
        "sliderTextHeaderBadge2": "Dynamisk kostnadshantering",
        "sliderTextHeaderBadge3": "Lär dig från din telefon!",
        "sliderTextHeaderBadge4": "Kostnadsfritt!",
        "sliderTextHeader1": "Oro för utebliven ankomst",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Din restaurangs status",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "LÄS MER",
        "UiKit_Fill_Min_Length_Field_Label": "Detta fält måste innehålla minst {{minLength}} tecken.",
        "UiKit_Fill_Out_Field_Label": "Detta fält måste fyllas i.",
        "Support": "Support",
        "Support_WhatsApp_Text": "Du kan nå oss via WhatsApp Live Support-linjen:",
        "Support_WhatsApp_Button": "WhatsApp Support-linje"
    },
    "da": {
        "Back_To_Dashboard": "Tilbage til dashboard",
        "Back_To_Products": "Tilbage til produkter",
        "Profile_Settings": "Profilindstillinger",
        "GoTo_Product": "Gå til produkt",
        "Start_Trial": "Start prøveperiode",
        "Learn": "Lær",
        "Reports": "Rapporter",
        "Status": "Status",
        "Free_Simpra_Account": "Lad os komme i gang med din gratis Simpra-konto",
        "Name": "Fornavn",
        "Surname": "Efternavn",
        "Email": "E-mail",
        "Phone_Code": "Landekode",
        "Phone_Number": "Telefonnummer",
        "Current_Password": "Nuværende adgangskode",
        "New_Password": "Ny adgangskode",
        "Confirm_New_Password": "Bekræft ny adgangskode",
        "Your_Account": "Er du færdig med din konto?",
        "Meet_Our_Products": "Oplev andre Simpra-produkter",
        "Meet_Our_Products_Description": "Opdag flere løsninger, der er skræddersyet til at opfylde alle dine forretningsbehov.",
        "New_Customer_Meet_Our_Products": "Oplev Simpra-produkter",
        "New_Customer_Meet_Our_Products_Description": "Opdag vores løsninger, der er designet til at opfylde alle dine forretningsbehov, og oplev forskellen.",
        "Sign_Out_From_Browser": "Log ud af denne browser",
        "Welcome": "Velkommen",
        "Sign_Out": "Log ud",
        "My_Permissions": "Mine tilladelser",
        "Campaign_Notifications": "Kampagnenotifikationer",
        "Campaign_Notifications_Question": "Vil du informeres om alle kampagner og notifikationer?",
        "Email_Permission": "Ja, jeg vil gerne underrettes via e-mail.",
        "SMS_Permission": "Ja, jeg vil gerne informeres via SMS.",
        "Phone_Permission": "Ja, jeg vil gerne underrettes via opkald.",
        "Close": "LUK",
        "POS_App_Only_Title": "Fortsæt fra vores app",
        "POS_App_Only_Message": "For at bruge Simpra POS skal du fortsætte fra vores iOS-, Android-mobilapps eller vores Windows-, MacOS-, Linux-desktopapps.",
        "Product_Inactive_Message": "Din adgang til dette produkt er i øjeblikket inaktiv. Kontakt din administrator.",
        "Chatbot_Button_Label": "HEJ!",
        "Recommended_For_Device": "Anbefalet til din enhed",
        "Other_Platforms": "Andre platforme",
        "Status_Operational": "Fungerer",
        "Status_Degraded": "Delvis nedbrud",
        "Status_Down": "Nede",
        "Save": "GEM",
        "Your_Products": "Dine produkter",
        "Your_Product_Message": "Løsninger designet til at opfylde alle dine forretningsbehov.",
        "All_Other_Products": "Alle andre produkter",
        "passwordRulesMessage": "Din adgangskode skal indeholde:",
        "passwordRules1": "Mindst 8 tegn",
        "passwordRules2": "Mindst 1 tal",
        "passwordRules3": "Mindst 1 stort bogstav",
        "passwordRules4": "Mindst 1 specialtegn",
        "Learn_More": "Læs mere",
        "Verified": "BEKRÆFTET",
        "Not_Verified": "IKKE BEKRÆFTET",
        "Change_My_Password": "Skift min adgangskode",
        "Change_My_Password_Content": "For at skifte din adgangskode kan du logge ud og bruge feltet “Glemt adgangskode” på loginsiden.",
        "Enter_Your_Name": "Indtast dit fornavn",
        "Enter_Your_Surname": "Indtast dit efternavn",
        "Enter_Your_Phone": "Indtast dit telefonnummer",
        "Chatbot_Welcome_Text": "Hej {{username}}! Spørg mig om hvad som helst om det Simpra-produkt, du vælger, så finder jeg et svar.",
        "Chatbot_First_Message": "Selvfølgelig, stil dit spørgsmål om Simpra Inventory-produktet.",
        "Chatbot_Ask_About_Products": "Spørg mig om vores produkter.",
        "Chatbot_Chat_Rating_Question": "Hvordan er din samtale med Simpra AI?",
        "Chatbot_End_Chat": "AFSLUT CHAT",
        "Chatbot_Send": "SEND",
        "Chatbot_Thank_You": "Tak",
        "Chatbot_Feedback_Text": "Simpra AI arbejder konstant på at forbedre feedbacken fra vores værdsatte kunder.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Hvilket produkt har du et spørgsmål om?",
        "Chatbot_Hello": "HEJ",
        "Chatbot_Hello_Text": "Hej {{username}}. Jeg er Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Med Simpra Reservation samler du alle dine reservationer ét sted uden tids- eller stedbegrænsninger. Administration er nu meget nemmere!",
        "sliderText2": "Med beregningen af glidende vægtet gennemsnitspris kan du se dine reelle omkostninger i realtid under skiftende økonomiske forhold og bevare din rentabilitet.",
        "sliderText3": "Følg din drift i realtid fra hvor som helst, udvikl præcise salgsstrategier og øg din omsætning med op til 15 %.",
        "sliderText4": "Dit menukort er altid opdateret og miljøvenligt! Nyd bekvemmeligheden ved kontaktløs bestilling og betaling med Order & Pay-plugin'et.",
        "sliderTextHeaderBadge1": "Stop det!",
        "sliderTextHeaderBadge2": "Dynamisk omkostningsstyring",
        "sliderTextHeaderBadge3": "Lær fra din telefon!",
        "sliderTextHeaderBadge4": "Gratis!",
        "sliderTextHeader1": "Ingen bekymring om udeblivelser",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Din restaurants status",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "LÆS MERE",
        "UiKit_Fill_Min_Length_Field_Label": "Dette felt skal indeholde mindst {{minLength}} tegn.",
        "UiKit_Fill_Out_Field_Label": "Dette felt skal udfyldes.",
        "Support": "Support",
        "Support_WhatsApp_Text": "Du kan kontakte os via WhatsApp Live Support-linjen:",
        "Support_WhatsApp_Button": "WhatsApp Support-linje"
    },
    "fi": {
        "Back_To_Dashboard": "Takaisin koontinäyttöön",
        "Back_To_Products": "Takaisin tuotteisiin",
        "Profile_Settings": "Profiiliasetukset",
        "GoTo_Product": "Siirry tuotteeseen",
        "Start_Trial": "Aloita kokeilujakso",
        "Learn": "Opi",
        "Reports": "Raportit",
        "Status": "Tila",
        "Free_Simpra_Account": "Aloitetaan ilmaisella Simpra-tililläsi",
        "Name": "Etunimi",
        "Surname": "Sukunimi",
        "Email": "Sähköposti",
        "Phone_Code": "Maakoodi",
        "Phone_Number": "Puhelinnumero",
        "Current_Password": "Nykyinen salasana",
        "New_Password": "Uusi salasana",
        "Confirm_New_Password": "Vahvista uusi salasana",
        "Your_Account": "Oletko valmis tilisi kanssa?",
        "Meet_Our_Products": "Tutustu muihin Simpra-tuotteisiin",
        "Meet_Our_Products_Description": "Löydä lisää ratkaisuja, jotka on räätälöity vastaamaan kaikkiin liiketoimintasi tarpeisiin.",
        "New_Customer_Meet_Our_Products": "Tutustu Simpra-tuotteisiin",
        "New_Customer_Meet_Our_Products_Description": "Löydä ratkaisumme, jotka on suunniteltu vastaamaan kaikkiin liiketoimintasi tarpeisiin, ja koe ero.",
        "Sign_Out_From_Browser": "Kirjaudu ulos tästä selaimesta",
        "Welcome": "Tervetuloa",
        "Sign_Out": "Kirjaudu ulos",
        "My_Permissions": "Omat käyttöoikeudet",
        "Campaign_Notifications": "Kampanjailmoitukset",
        "Campaign_Notifications_Question": "Haluatko tietoa kaikista kampanjoista ja ilmoituksista?",
        "Email_Permission": "Kyllä, haluan saada ilmoituksia sähköpostitse.",
        "SMS_Permission": "Kyllä, haluan saada tietoa tekstiviestitse.",
        "Phone_Permission": "Kyllä, haluan saada ilmoituksia puhelimitse.",
        "Close": "SULJE",
        "POS_App_Only_Title": "Jatka sovelluksestamme",
        "POS_App_Only_Message": "Käyttääksesi Simpra POS -sovellusta jatka iOS- tai Android-mobiilisovelluksistamme tai Windows-, MacOS- tai Linux-työpöytäsovelluksistamme.",
        "Product_Inactive_Message": "Käyttöoikeutesi tähän tuotteeseen ei ole tällä hetkellä aktiivinen. Ota yhteyttä järjestelmänvalvojaan.",
        "Chatbot_Button_Label": "HEI!",
        "Recommended_For_Device": "Suositeltu laitteellesi",
        "Other_Platforms": "Muut alustat",
        "Status_Operational": "Toiminnassa",
        "Status_Degraded": "Osittainen katkos",
        "Status_Down": "Alhaalla",
        "Save": "TALLENNA",
        "Your_Products": "Tuotteesi",
        "Your_Product_Message": "Ratkaisuja, jotka on suunniteltu vastaamaan kaikkiin liiketoimintasi tarpeisiin.",
        "All_Other_Products": "Kaikki muut tuotteet",
        "passwordRulesMessage": "Salasanasi on sisällettävä:",
        "passwordRules1": "Vähintään 8 merkkiä",
        "passwordRules2": "Vähintään 1 numero",
        "passwordRules3": "Vähintään 1 iso kirjain",
        "passwordRules4": "Vähintään 1 erikoismerkki",
        "Learn_More": "Lue lisää",
        "Verified": "VAHVISTETTU",
        "Not_Verified": "EI VAHVISTETTU",
        "Change_My_Password": "Vaihda salasanani",
        "Change_My_Password_Content": "Vaihtaaksesi salasanasi voit kirjautua ulos ja käyttää kirjautumissivun “Unohtuiko salasana” -kenttää.",
        "Enter_Your_Name": "Kirjoita etunimesi",
        "Enter_Your_Surname": "Kirjoita sukunimesi",
        "Enter_Your_Phone": "Kirjoita puhelinnumerosi",
        "Chatbot_Welcome_Text": "Hei {{username}}! Kysy minulta mitä tahansa valitsemastasi Simpra-tuotteesta, niin löydän vastauksen.",
        "Chatbot_First_Message": "Toki, kysy kysymyksesi Simpra Inventory -tuotteesta.",
        "Chatbot_Ask_About_Products": "Kysy minulta tuotteistamme.",
        "Chatbot_Chat_Rating_Question": "Millainen keskustelusi Simpra AI:n kanssa on?",
        "Chatbot_End_Chat": "LOPETA KESKUSTELU",
        "Chatbot_Send": "LÄHETÄ",
        "Chatbot_Thank_You": "Kiitos",
        "Chatbot_Feedback_Text": "Simpra AI työskentelee jatkuvasti parantaakseen arvostettujen asiakkaidemme palautetta.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Mistä tuotteesta sinulla on kysyttävää?",
        "Chatbot_Hello": "HEI",
        "Chatbot_Hello_Text": "Hei {{username}}. Olen Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Simpra Reservationin avulla kokoat kaikki varauksesi yhteen paikkaan ilman aika- tai paikkarajoituksia. Hallinta on nyt paljon helpompaa!",
        "sliderText2": "Liukuvan painotetun keskihinnan laskennan avulla näet todelliset kustannuksesi reaaliajassa muuttuvissa taloudellisissa olosuhteissa ja säilytät kannattavuutesi.",
        "sliderText3": "Seuraa toimintaasi reaaliajassa mistä tahansa, kehitä tarkkoja myyntistrategioita ja kasvata tulojasi jopa 15 %.",
        "sliderText4": "Menusi on aina ajan tasalla ja ympäristöystävällinen! Nauti kontaktittoman tilaamisen ja maksamisen mukavuudesta Order & Pay -laajennuksen avulla.",
        "sliderTextHeaderBadge1": "Lopeta se!",
        "sliderTextHeaderBadge2": "Dynaaminen kustannusten hallinta",
        "sliderTextHeaderBadge3": "Opi puhelimestasi!",
        "sliderTextHeaderBadge4": "Ilmaiseksi!",
        "sliderTextHeader1": "Ei huolta peruuntumisista",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Ravintolasi tila",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "LUE LISÄÄ",
        "UiKit_Fill_Min_Length_Field_Label": "Tässä kentässä on oltava vähintään {{minLength}} merkkiä.",
        "UiKit_Fill_Out_Field_Label": "Tämä kenttä on täytettävä.",
        "Support": "Tuki",
        "Support_WhatsApp_Text": "Voit ottaa meihin yhteyttä WhatsApp-live-tukilinjan kautta:",
        "Support_WhatsApp_Button": "WhatsApp-tukilinja"
    },
    "no": {
        "Back_To_Dashboard": "Tilbake til dashbord",
        "Back_To_Products": "Tilbake til produkter",
        "Profile_Settings": "Profilinnstillinger",
        "GoTo_Product": "Gå til produkt",
        "Start_Trial": "Start prøveperiode",
        "Learn": "Lær",
        "Reports": "Rapporter",
        "Status": "Status",
        "Free_Simpra_Account": "La oss komme i gang med din gratis Simpra-konto",
        "Name": "Fornavn",
        "Surname": "Etternavn",
        "Email": "E-post",
        "Phone_Code": "Landskode",
        "Phone_Number": "Telefonnummer",
        "Current_Password": "Nåværende passord",
        "New_Password": "Nytt passord",
        "Confirm_New_Password": "Bekreft nytt passord",
        "Your_Account": "Er du ferdig med kontoen din?",
        "Meet_Our_Products": "Opplev andre Simpra-produkter",
        "Meet_Our_Products_Description": "Oppdag flere løsninger skreddersydd for å møte alle dine forretningsbehov.",
        "New_Customer_Meet_Our_Products": "Opplev Simpra-produkter",
        "New_Customer_Meet_Our_Products_Description": "Oppdag våre løsninger designet for å møte alle dine forretningsbehov, og opplev forskjellen.",
        "Sign_Out_From_Browser": "Logg ut av denne nettleseren",
        "Welcome": "Velkommen",
        "Sign_Out": "Logg ut",
        "My_Permissions": "Mine tillatelser",
        "Campaign_Notifications": "Kampanjevarsler",
        "Campaign_Notifications_Question": "Vil du bli informert om alle kampanjer og varsler?",
        "Email_Permission": "Ja, jeg vil bli varslet via e-post.",
        "SMS_Permission": "Ja, jeg vil bli informert via SMS.",
        "Phone_Permission": "Ja, jeg vil bli varslet via telefon.",
        "Close": "LUKK",
        "POS_App_Only_Title": "Fortsett fra appen vår",
        "POS_App_Only_Message": "For å bruke Simpra POS, vennligst fortsett fra våre iOS-, Android-mobilapper eller våre Windows-, MacOS-, Linux-skrivebordsapper.",
        "Product_Inactive_Message": "Tilgangen din til dette produktet er for øyeblikket inaktiv. Kontakt administratoren din.",
        "Chatbot_Button_Label": "HEI!",
        "Recommended_For_Device": "Anbefalt for enheten din",
        "Other_Platforms": "Andre plattformer",
        "Status_Operational": "I drift",
        "Status_Degraded": "Delvis nedetid",
        "Status_Down": "Nede",
        "Save": "LAGRE",
        "Your_Products": "Dine produkter",
        "Your_Product_Message": "Løsninger designet for å møte alle dine forretningsbehov.",
        "All_Other_Products": "Alle andre produkter",
        "passwordRulesMessage": "Passordet ditt må inneholde:",
        "passwordRules1": "Minst 8 tegn",
        "passwordRules2": "Minst 1 tall",
        "passwordRules3": "Minst 1 stor bokstav",
        "passwordRules4": "Minst 1 spesialtegn",
        "Learn_More": "Lær mer",
        "Verified": "BEKREFTET",
        "Not_Verified": "IKKE BEKREFTET",
        "Change_My_Password": "Endre passordet mitt",
        "Change_My_Password_Content": "For å endre passordet ditt kan du logge ut og bruke feltet “Glemt passord” på innloggingssiden.",
        "Enter_Your_Name": "Skriv inn fornavnet ditt",
        "Enter_Your_Surname": "Skriv inn etternavnet ditt",
        "Enter_Your_Phone": "Skriv inn telefonnummeret ditt",
        "Chatbot_Welcome_Text": "Hei {{username}}! Spør meg om hva som helst om Simpra-produktet du velger, så finner jeg et svar.",
        "Chatbot_First_Message": "Selvfølgelig, still spørsmålet ditt om Simpra Inventory-produktet.",
        "Chatbot_Ask_About_Products": "Spør meg om produktene våre.",
        "Chatbot_Chat_Rating_Question": "Hvordan er samtalen din med Simpra AI?",
        "Chatbot_End_Chat": "AVSLUTT CHAT",
        "Chatbot_Send": "SEND",
        "Chatbot_Thank_You": "Takk",
        "Chatbot_Feedback_Text": "Simpra AI jobber kontinuerlig med å forbedre tilbakemeldingene fra våre verdsatte kunder.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Hvilket produkt har du et spørsmål om?",
        "Chatbot_Hello": "HEI",
        "Chatbot_Hello_Text": "Hei {{username}}. Jeg er Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Med Simpra Reservation samler du alle reservasjonene dine på ett sted uten tids- eller stedsbegrensninger. Administrasjon er nå mye enklere!",
        "sliderText2": "Med beregningen av glidende vektet gjennomsnittskostnad ser du de reelle kostnadene dine i sanntid under skiftende økonomiske forhold og opprettholder lønnsomheten din.",
        "sliderText3": "Følg driften din i sanntid fra hvor som helst, utvikl nøyaktige salgsstrategier og øk inntektene dine med opptil 15 %.",
        "sliderText4": "Menyen din er alltid oppdatert og miljøvennlig! Nyt bekvemmeligheten ved kontaktløs bestilling og betaling med Order & Pay-programtillegget.",
        "sliderTextHeaderBadge1": "Få slutt på det!",
        "sliderTextHeaderBadge2": "Dynamisk kostnadsstyring",
        "sliderTextHeaderBadge3": "Lær fra telefonen din!",
        "sliderTextHeaderBadge4": "Gratis!",
        "sliderTextHeader1": "Ingen bekymring for uteblivelser",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Statusen til restauranten din",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "LÆR MER",
        "UiKit_Fill_Min_Length_Field_Label": "Dette feltet må inneholde minst {{minLength}} tegn.",
        "UiKit_Fill_Out_Field_Label": "Dette feltet må fylles ut.",
        "Support": "Support",
        "Support_WhatsApp_Text": "Du kan nå oss via WhatsApp Live Support-linjen:",
        "Support_WhatsApp_Button": "WhatsApp Support-linje"
    },
"hu": {
    "Back_To_Dashboard": "Vissza az irányítópultra",
    "Back_To_Products": "Vissza a termékekhez",
    "Profile_Settings": "Profilbeállítások",
    "GoTo_Product": "Ugrás a termékhez",
    "Start_Trial": "Próbaidőszak indítása",
    "Learn": "Tanulás",
    "Reports": "Jelentések",
    "Status": "Állapot",
    "Free_Simpra_Account": "Kezdjük az ingyenes Simpra fiókoddal",
    "Name": "Keresztnév",
    "Surname": "Vezetéknév",
    "Email": "E-mail",
    "Phone_Code": "Országhívó",
    "Phone_Number": "Telefonszám",
    "Current_Password": "Jelenlegi jelszó",
    "New_Password": "Új jelszó",
    "Confirm_New_Password": "Új jelszó megerősítése",
    "Your_Account": "Végeztél a fiókoddal?",
    "Meet_Our_Products": "Fedezd fel a többi Simpra terméket",
    "Meet_Our_Products_Description": "Fedezz fel további megoldásokat, amelyeket vállalkozásod minden igényére szabtunk.",
    "New_Customer_Meet_Our_Products": "Ismerd meg a Simpra termékeit",
    "New_Customer_Meet_Our_Products_Description": "Fedezd fel a vállalkozásod minden igényét kielégítő megoldásainkat, és tapasztald meg a különbséget.",
    "Sign_Out_From_Browser": "Kijelentkezés ebből a böngészőből",
    "Welcome": "Üdvözlünk",
    "Sign_Out": "Kijelentkezés",
    "My_Permissions": "Engedélyeim",
    "Campaign_Notifications": "Kampányértesítések",
    "Campaign_Notifications_Question": "Szeretnél értesülni minden kampányról és értesítésről?",
    "Email_Permission": "Igen, szeretnék e-mailben értesítést kapni.",
    "SMS_Permission": "Igen, szeretnék SMS-ben értesítést kapni.",
    "Phone_Permission": "Igen, szeretnék telefonhívással értesítést kapni.",
    "Close": "BEZÁRÁS",
    "POS_App_Only_Title": "Folytasd az alkalmazásunkból",
    "POS_App_Only_Message": "A Simpra POS használatához folytasd iOS vagy Android mobilalkalmazásunkból, illetve Windows, MacOS vagy Linux asztali alkalmazásunkból.",
    "Product_Inactive_Message": "A termékhez való hozzáférésed jelenleg inaktív. Kérjük, vedd fel a kapcsolatot a rendszergazdával.",
    "Chatbot_Button_Label": "SZIA!",
    "Recommended_For_Device": "Ajánlott az eszközödhöz",
    "Other_Platforms": "Egyéb platformok",
    "Status_Operational": "Működik",
    "Status_Degraded": "Részleges üzemzavar",
    "Status_Down": "Nem működik",
    "Save": "MENTÉS",
    "Your_Products": "A termékeid",
    "Your_Product_Message": "Vállalkozásod minden igényére tervezett megoldások.",
    "All_Other_Products": "Az összes többi termék",
    "passwordRulesMessage": "A jelszavadnak tartalmaznia kell:",
    "passwordRules1": "Legalább 8 karaktert",
    "passwordRules2": "Legalább 1 számot",
    "passwordRules3": "Legalább 1 nagybetűt",
    "passwordRules4": "Legalább 1 speciális karaktert",
    "Learn_More": "További információ",
    "Verified": "MEGERŐSÍTVE",
    "Not_Verified": "NINCS MEGERŐSÍTVE",
    "Change_My_Password": "Jelszó módosítása",
    "Change_My_Password_Content": "A jelszavad módosításához jelentkezz ki, és használd az „Elfelejtett jelszó” mezőt a bejelentkezési oldalon.",
    "Enter_Your_Name": "Add meg a keresztneved",
    "Enter_Your_Surname": "Add meg a vezetékneved",
    "Enter_Your_Phone": "Add meg a telefonszámod",
    "Chatbot_Welcome_Text": "Szia {{username}}! Kérdezz bármit a választott Simpra termékről, és megkeresem a választ.",
    "Chatbot_First_Message": "Persze, tedd fel a kérdésedet a Simpra Inventory termékkel kapcsolatban.",
    "Chatbot_Ask_About_Products": "Kérdezz a termékeinkről.",
    "Chatbot_Chat_Rating_Question": "Milyen a beszélgetésed a Simpra AI-jal?",
    "Chatbot_End_Chat": "BESZÉLGETÉS BEFEJEZÉSE",
    "Chatbot_Send": "KÜLDÉS",
    "Chatbot_Thank_You": "Köszönjük",
    "Chatbot_Feedback_Text": "A Simpra AI folyamatosan dolgozik értékes ügyfeleink visszajelzéseinek javításán.",
    "Chatbot_Simpra_AI": "Simpra AI",
    "Chatbot_Product_Selection_Question": "Melyik termékkel kapcsolatban van kérdésed?",
    "Chatbot_Hello": "SZIA",
    "Chatbot_Hello_Text": "Szia {{username}}. Simpra AI vagyok",
    "Simpra_Reports": "Simpra Reports",
    "sliderText1": "A Simpra Reservation segítségével gyűjtsd össze az összes foglalásodat egy helyen, idő- és helyszínbeli korlátozások nélkül. A kezelés mostantól sokkal egyszerűbb!",
    "sliderText2": "A mozgó súlyozott átlagköltség számításával valós időben láthatod a tényleges költségeidet a változó gazdasági körülmények között, és megőrizheted a jövedelmezőségedet.",
    "sliderText3": "Kövesd nyomon a működésedet valós időben bárhonnan, dolgozz ki pontos értékesítési stratégiákat, és növeld a bevételedet akár 15%-kal.",
    "sliderText4": "A menüd mindig naprakész és környezetbarát! Élvezd az érintésmentes rendelés és fizetés kényelmét az Order & Pay bővítménnyel.",
    "sliderTextHeaderBadge1": "Vess neki véget!",
    "sliderTextHeaderBadge2": "Dinamikus költségkezelés",
    "sliderTextHeaderBadge3": "Tanulj a telefonodról!",
    "sliderTextHeaderBadge4": "Ingyenesen!",
    "sliderTextHeader1": "No-show aggodalom",
    "sliderTextHeader2": "Simpra Inventory",
    "sliderTextHeader3": "Az éttermed állapota",
    "sliderTextHeader4": "Simpra QR Menu",
    "learnMore": "TOVÁBBI INFORMÁCIÓ",
    "UiKit_Fill_Min_Length_Field_Label": "Ennek a mezőnek legalább {{minLength}} karakter hosszúnak kell lennie.",
    "UiKit_Fill_Out_Field_Label": "Ezt a mezőt ki kell tölteni.",
        "Support": "Támogatás",
        "Support_WhatsApp_Text": "Elérhet minket a WhatsApp élő ügyfélszolgálati vonalon keresztül:",
        "Support_WhatsApp_Button": "WhatsApp ügyfélszolgálat"
},
"hr": {
    "Back_To_Dashboard": "Natrag na nadzornu ploču",
    "Back_To_Products": "Natrag na proizvode",
    "Profile_Settings": "Postavke profila",
    "GoTo_Product": "Idi na proizvod",
    "Start_Trial": "Započni probno razdoblje",
    "Learn": "Uči",
    "Reports": "Izvještaji",
    "Status": "Status",
    "Free_Simpra_Account": "Započnimo s vašim besplatnim Simpra računom",
    "Name": "Ime",
    "Surname": "Prezime",
    "Email": "E-pošta",
    "Phone_Code": "Pozivni broj",
    "Phone_Number": "Telefonski broj",
    "Current_Password": "Trenutna lozinka",
    "New_Password": "Nova lozinka",
    "Confirm_New_Password": "Potvrdite novu lozinku",
    "Your_Account": "Jeste li gotovi sa svojim računom?",
    "Meet_Our_Products": "Isprobajte ostale Simpra proizvode",
    "Meet_Our_Products_Description": "Otkrijte više rješenja prilagođenih svim potrebama vašeg poslovanja.",
    "New_Customer_Meet_Our_Products": "Isprobajte Simpra proizvode",
    "New_Customer_Meet_Our_Products_Description": "Otkrijte naša rješenja osmišljena za sve potrebe vašeg poslovanja i osjetite razliku.",
    "Sign_Out_From_Browser": "Odjava iz ovog preglednika",
    "Welcome": "Dobrodošli",
    "Sign_Out": "Odjava",
    "My_Permissions": "Moja dopuštenja",
    "Campaign_Notifications": "Obavijesti o kampanjama",
    "Campaign_Notifications_Question": "Želite li biti obaviješteni o svim kampanjama i obavijestima?",
    "Email_Permission": "Da, želim primati obavijesti putem e-pošte.",
    "SMS_Permission": "Da, želim biti obaviješten putem SMS-a.",
    "Phone_Permission": "Da, želim biti obaviješten pozivom.",
    "Close": "ZATVORI",
    "POS_App_Only_Title": "Nastavite putem naše aplikacije",
    "POS_App_Only_Message": "Za korištenje Simpra POS-a nastavite putem naših iOS, Android mobilnih aplikacija ili naših Windows, MacOS, Linux desktop aplikacija.",
    "Product_Inactive_Message": "Vaš pristup ovom proizvodu trenutno nije aktivan. Obratite se svom administratoru.",
    "Chatbot_Button_Label": "ZDRAVO!",
    "Recommended_For_Device": "Preporučeno za vaš uređaj",
    "Other_Platforms": "Ostale platforme",
    "Status_Operational": "Operativno",
    "Status_Degraded": "Djelomični prekid",
    "Status_Down": "Nedostupno",
    "Save": "SPREMI",
    "Your_Products": "Vaši proizvodi",
    "Your_Product_Message": "Rješenja osmišljena za sve potrebe vašeg poslovanja.",
    "All_Other_Products": "Svi ostali proizvodi",
    "passwordRulesMessage": "Vaša lozinka mora sadržavati:",
    "passwordRules1": "Najmanje 8 znakova",
    "passwordRules2": "Najmanje 1 broj",
    "passwordRules3": "Najmanje 1 veliko slovo",
    "passwordRules4": "Najmanje 1 posebni znak",
    "Learn_More": "Saznajte više",
    "Verified": "POTVRĐENO",
    "Not_Verified": "NIJE POTVRĐENO",
    "Change_My_Password": "Promijeni moju lozinku",
    "Change_My_Password_Content": "Za promjenu lozinke možete se odjaviti i koristiti polje „Zaboravljena lozinka” na stranici za prijavu.",
    "Enter_Your_Name": "Unesite svoje ime",
    "Enter_Your_Surname": "Unesite svoje prezime",
    "Enter_Your_Phone": "Unesite svoj telefon",
    "Chatbot_Welcome_Text": "Pozdrav {{username}}! Pitajte me bilo što o Simpra proizvodu po vašem izboru i pronaći ću odgovor.",
    "Chatbot_First_Message": "Naravno, postavite svoje pitanje o proizvodu Simpra Inventory.",
    "Chatbot_Ask_About_Products": "Pitajte me o našim proizvodima.",
    "Chatbot_Chat_Rating_Question": "Kakav je vaš razgovor sa Simpra AI?",
    "Chatbot_End_Chat": "ZAVRŠI RAZGOVOR",
    "Chatbot_Send": "POŠALJI",
    "Chatbot_Thank_You": "Hvala vam",
    "Chatbot_Feedback_Text": "Simpra AI neprestano radi na poboljšanju povratnih informacija naših cijenjenih kupaca.",
    "Chatbot_Simpra_AI": "Simpra AI",
    "Chatbot_Product_Selection_Question": "O kojem proizvodu imate pitanje?",
    "Chatbot_Hello": "POZDRAV",
    "Chatbot_Hello_Text": "Bok {{username}}. Ja sam Simpra AI",
    "Simpra_Reports": "Simpra Reports",
    "sliderText1": "Uz Simpra Reservation prikupite sve svoje rezervacije na jednom mjestu bez ograničenja vremena i lokacije. Upravljanje je sada mnogo jednostavnije!",
    "sliderText2": "Uz izračun pomičnog ponderiranog prosječnog troška, vidite svoje stvarne troškove u stvarnom vremenu u promjenjivim ekonomskim uvjetima i zadržite svoju profitabilnost.",
    "sliderText3": "Pratite svoje poslovanje u stvarnom vremenu s bilo kojeg mjesta, razvijajte točne prodajne strategije i povećajte svoje prihode do 15%.",
    "sliderText4": "Vaš je jelovnik uvijek ažuran i ekološki prihvatljiv! Uživajte u praktičnosti beskontaktnog naručivanja i plaćanja uz dodatak Order & Pay.",
    "sliderTextHeaderBadge1": "Prekinite to!",
    "sliderTextHeaderBadge2": "Dinamičko upravljanje troškovima",
    "sliderTextHeaderBadge3": "Učite s telefona!",
    "sliderTextHeaderBadge4": "Besplatno!",
    "sliderTextHeader1": "Briga o nedolascima",
    "sliderTextHeader2": "Simpra Inventory",
    "sliderTextHeader3": "Status vašeg restorana",
    "sliderTextHeader4": "Simpra QR Menu",
    "learnMore": "SAZNAJTE VIŠE",
    "UiKit_Fill_Min_Length_Field_Label": "Ovo polje mora imati najmanje {{minLength}} znakova.",
    "UiKit_Fill_Out_Field_Label": "Ovo polje mora biti popunjeno.",
        "Support": "Podrška",
        "Support_WhatsApp_Text": "Možete nas kontaktirati putem WhatsApp linije za podršku uživo:",
        "Support_WhatsApp_Button": "WhatsApp linija za podršku"
},
"mk": {
    "Back_To_Dashboard": "Назад на контролната табла",
    "Back_To_Products": "Назад на производите",
    "Profile_Settings": "Поставки на профилот",
    "GoTo_Product": "Оди на производот",
    "Start_Trial": "Започни пробен период",
    "Learn": "Учи",
    "Reports": "Извештаи",
    "Status": "Статус",
    "Free_Simpra_Account": "Ајде да започнеме со вашата бесплатна Simpra сметка",
    "Name": "Име",
    "Surname": "Презиме",
    "Email": "Е-пошта",
    "Phone_Code": "Повикувачки код",
    "Phone_Number": "Телефонски број",
    "Current_Password": "Тековна лозинка",
    "New_Password": "Нова лозинка",
    "Confirm_New_Password": "Потврди ја новата лозинка",
    "Your_Account": "Дали завршивте со вашата сметка?",
    "Meet_Our_Products": "Искусете ги другите Simpra производи",
    "Meet_Our_Products_Description": "Откријте повеќе решенија прилагодени на сите потреби на вашиот бизнис.",
    "New_Customer_Meet_Our_Products": "Искусете ги Simpra производите",
    "New_Customer_Meet_Our_Products_Description": "Откријте ги нашите решенија дизајнирани да ги задоволат сите потреби на вашиот бизнис и почувствувајте ја разликата.",
    "Sign_Out_From_Browser": "Одјава од овој прелистувач",
    "Welcome": "Добредојдовте",
    "Sign_Out": "Одјава",
    "My_Permissions": "Мои дозволи",
    "Campaign_Notifications": "Известувања за кампањи",
    "Campaign_Notifications_Question": "Дали сакате да бидете информирани за сите кампањи и известувања?",
    "Email_Permission": "Да, сакам да бидам известуван преку е-пошта.",
    "SMS_Permission": "Да, сакам да бидам известуван преку SMS.",
    "Phone_Permission": "Да, сакам да бидам известуван преку телефонски повик.",
    "Close": "ЗАТВОРИ",
    "POS_App_Only_Title": "Продолжете преку нашата апликација",
    "POS_App_Only_Message": "За да го користите Simpra POS, продолжете преку нашите iOS, Android мобилни апликации или нашите Windows, MacOS, Linux десктоп апликации.",
    "Product_Inactive_Message": "Вашиот пристап до овој производ моментално не е активен. Контактирајте го администраторот.",
    "Chatbot_Button_Label": "ЗДРАВО!",
    "Recommended_For_Device": "Препорачано за вашиот уред",
    "Other_Platforms": "Други платформи",
    "Status_Operational": "Оперативно",
    "Status_Degraded": "Делумен прекин",
    "Status_Down": "Недостапно",
    "Save": "ЗАЧУВАЈ",
    "Your_Products": "Вашите производи",
    "Your_Product_Message": "Решенија дизајнирани да ги задоволат сите потреби на вашиот бизнис.",
    "All_Other_Products": "Сите други производи",
    "passwordRulesMessage": "Вашата лозинка мора да содржи:",
    "passwordRules1": "Најмалку 8 знаци",
    "passwordRules2": "Најмалку 1 број",
    "passwordRules3": "Најмалку 1 голема буква",
    "passwordRules4": "Најмалку 1 специјален знак",
    "Learn_More": "Дознајте повеќе",
    "Verified": "ПОТВРДЕНО",
    "Not_Verified": "НЕ Е ПОТВРДЕНО",
    "Change_My_Password": "Променете ја мојата лозинка",
    "Change_My_Password_Content": "За да ја промените вашата лозинка, можете да се одјавите и да го користите полето „Заборавена лозинка“ на страницата за најава.",
    "Enter_Your_Name": "Внесете го вашето име",
    "Enter_Your_Surname": "Внесете го вашето презиме",
    "Enter_Your_Phone": "Внесете го вашиот телефон",
    "Chatbot_Welcome_Text": "Здраво {{username}}! Прашајте ме што било за Simpra производот по ваш избор и јас ќе најдам одговор.",
    "Chatbot_First_Message": "Секако, поставете го вашето прашање за производот Simpra Inventory.",
    "Chatbot_Ask_About_Products": "Прашајте ме за нашите производи.",
    "Chatbot_Chat_Rating_Question": "Каков е вашиот разговор со Simpra AI?",
    "Chatbot_End_Chat": "ЗАВРШИ РАЗГОВОР",
    "Chatbot_Send": "ИСПРАТИ",
    "Chatbot_Thank_You": "Ви благодариме",
    "Chatbot_Feedback_Text": "Simpra AI постојано работи на подобрување на повратните информации од нашите ценети клиенти.",
    "Chatbot_Simpra_AI": "Simpra AI",
    "Chatbot_Product_Selection_Question": "За кој производ имате прашање?",
    "Chatbot_Hello": "ЗДРАВО",
    "Chatbot_Hello_Text": "Здраво {{username}}. Јас сум Simpra AI",
    "Simpra_Reports": "Simpra Reports",
    "sliderText1": "Со Simpra Reservation, соберете ги сите ваши резервации на едно место без никакви временски или локациски ограничувања. Управувањето сега е многу полесно!",
    "sliderText2": "Со пресметката на подвижниот пондериран просечен трошок, видете ги вашите реални трошоци во реално време во променливи економски услови и одржете ја вашата профитабилност.",
    "sliderText3": "Следете ги вашите операции во реално време од каде било, развивајте точни продажни стратегии и зголемете го вашиот приход до 15%.",
    "sliderText4": "Вашето мени е секогаш ажурирано и еколошко! Уживајте во погодноста на безконтактно нарачување и плаќање со додатокот Order & Pay.",
    "sliderTextHeaderBadge1": "Ставете крај на тоа!",
    "sliderTextHeaderBadge2": "Динамично управување со трошоци",
    "sliderTextHeaderBadge3": "Учете од вашиот телефон!",
    "sliderTextHeaderBadge4": "Бесплатно!",
    "sliderTextHeader1": "Грижа за непојавување",
    "sliderTextHeader2": "Simpra Inventory",
    "sliderTextHeader3": "Статусот на вашиот ресторан",
    "sliderTextHeader4": "Simpra QR Menu",
    "learnMore": "ДОЗНАЈТЕ ПОВЕЌЕ",
    "UiKit_Fill_Min_Length_Field_Label": "Ова поле мора да има најмалку {{minLength}} знаци.",
    "UiKit_Fill_Out_Field_Label": "Ова поле мора да биде пополнето.",
        "Support": "Поддршка",
        "Support_WhatsApp_Text": "Може да не контактирате преку WhatsApp линијата за поддршка во живо:",
        "Support_WhatsApp_Button": "WhatsApp линија за поддршка"
},
    "az": {
        "Back_To_Dashboard": "İdarə panelinə qayıt",
        "Back_To_Products": "Məhsullara qayıt",
        "Profile_Settings": "Profil parametrləri",
        "GoTo_Product": "Məhsula keç",
        "Start_Trial": "Sınaq müddətini başlat",
        "Learn": "Öyrən",
        "Reports": "Hesabatlar",
        "Status": "Status",
        "Free_Simpra_Account": "Pulsuz Simpra hesabınızla başlayaq",
        "Name": "Ad",
        "Surname": "Soyad",
        "Email": "E-poçt",
        "Phone_Code": "Ölkə kodu",
        "Phone_Number": "Telefon nömrəsi",
        "Current_Password": "Cari parol",
        "New_Password": "Yeni parol",
        "Confirm_New_Password": "Yeni parolu təsdiqləyin",
        "Your_Account": "Hesabınızla işiniz bitdi?",
        "Meet_Our_Products": "Digər Simpra məhsullarını sınayın",
        "Meet_Our_Products_Description": "Bütün biznes ehtiyaclarınıza uyğun daha çox həll kəşf edin.",
        "New_Customer_Meet_Our_Products": "Simpra məhsullarını sınayın",
        "New_Customer_Meet_Our_Products_Description": "Bütün biznes ehtiyaclarınızı qarşılamaq üçün hazırlanmış həllərimizi kəşf edin və fərqi yaşayın.",
        "Sign_Out_From_Browser": "Bu brauzerdən çıxış edin",
        "Welcome": "Xoş gəlmisiniz",
        "Sign_Out": "Çıxış",
        "My_Permissions": "İcazələrim",
        "Campaign_Notifications": "Kampaniya bildirişləri",
        "Campaign_Notifications_Question": "Bütün kampaniyalar və bildirişlər barədə məlumatlandırılmaq istəyirsiniz?",
        "Email_Permission": "Bəli, e-poçt vasitəsilə məlumatlandırılmaq istəyirəm.",
        "SMS_Permission": "Bəli, SMS vasitəsilə məlumatlandırılmaq istəyirəm.",
        "Phone_Permission": "Bəli, zəng vasitəsilə məlumatlandırılmaq istəyirəm.",
        "Close": "BAĞLA",
        "POS_App_Only_Title": "Tətbiqimizdən davam edin",
        "POS_App_Only_Message": "Simpra POS istifadə etmək üçün, zəhmət olmasa iOS, Android mobil tətbiqlərimizdən və ya Windows, MacOS, Linux masaüstü tətbiqlərimizdən davam edin.",
        "Product_Inactive_Message": "Bu məhsula girişiniz hazırda aktiv deyil. Zəhmət olmasa administratorunuzla əlaqə saxlayın.",
        "Chatbot_Button_Label": "SALAM!",
        "Recommended_For_Device": "Cihazınız üçün tövsiyə olunur",
        "Other_Platforms": "Digər platformalar",
        "Status_Operational": "İşlək",
        "Status_Degraded": "Qismən kəsinti",
        "Status_Down": "İşləmir",
        "Save": "YADDA SAXLA",
        "Your_Products": "Məhsullarınız",
        "Your_Product_Message": "Bütün biznes ehtiyaclarınızı qarşılamaq üçün hazırlanmış həllər.",
        "All_Other_Products": "Bütün digər məhsullar",
        "passwordRulesMessage": "Parolunuz aşağıdakıları ehtiva etməlidir:",
        "passwordRules1": "Ən azı 8 simvol",
        "passwordRules2": "Ən azı 1 rəqəm",
        "passwordRules3": "Ən azı 1 böyük hərf",
        "passwordRules4": "Ən azı 1 xüsusi simvol",
        "Learn_More": "Ətraflı öyrən",
        "Verified": "TƏSDİQLƏNİB",
        "Not_Verified": "TƏSDİQLƏNMƏYİB",
        "Change_My_Password": "Parolumu dəyişdir",
        "Change_My_Password_Content": "Parolunuzu dəyişdirmək üçün çıxış edib giriş səhifəsindəki “Parolu unutdum” bölməsindən istifadə edə bilərsiniz.",
        "Enter_Your_Name": "Adınızı daxil edin",
        "Enter_Your_Surname": "Soyadınızı daxil edin",
        "Enter_Your_Phone": "Telefonunuzu daxil edin",
        "Chatbot_Welcome_Text": "Salam {{username}}! Seçdiyiniz Simpra məhsulu haqqında istənilən sualı verin, mən cavab tapacağam.",
        "Chatbot_First_Message": "Əlbəttə, Simpra Inventory məhsulu haqqında sualınızı verin.",
        "Chatbot_Ask_About_Products": "Məhsullarımız haqqında soruşun.",
        "Chatbot_Chat_Rating_Question": "Simpra AI ilə söhbətiniz necə keçir?",
        "Chatbot_End_Chat": "SÖHBƏTİ BİTİR",
        "Chatbot_Send": "GÖNDƏR",
        "Chatbot_Thank_You": "Təşəkkür edirik",
        "Chatbot_Feedback_Text": "Simpra AI dəyərli müştərilərimizin rəylərini yaxşılaşdırmaq üçün daim çalışır.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Hansı məhsul haqqında sualınız var?",
        "Chatbot_Hello": "SALAM",
        "Chatbot_Hello_Text": "Salam {{username}}. Mən Simpra AI-yəm",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Simpra Reservation ilə bütün rezervasiyalarınızı zaman və məkan məhdudiyyəti olmadan bir yerdə toplayın. İdarəetmə artıq çox daha asandır!",
        "sliderText2": "Hərəkətli Çəkili Orta Maya hesablaması ilə dəyişən iqtisadi şəraitdə real xərclərinizi real vaxtda görün və gəlirliliyinizi qoruyun.",
        "sliderText3": "Əməliyyatlarınızı istənilən yerdən real vaxtda izləyin, düzgün satış strategiyaları hazırlayın və gəlirinizi 15%-ə qədər artırın.",
        "sliderText4": "Menyunuz həmişə güncəl və ekoloji cəhətdən təmizdir! Order & Pay plaginı ilə təmassız sifariş və ödənişin rahatlığını yaşayın.",
        "sliderTextHeaderBadge1": "Sona qoyun!",
        "sliderTextHeaderBadge2": "Dinamik maya idarəetməsi",
        "sliderTextHeaderBadge3": "Telefonunuzdan öyrənin!",
        "sliderTextHeaderBadge4": "Tamamilə pulsuz!",
        "sliderTextHeader1": "Gəlməmə narahatlığı",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Restoranınızın vəziyyəti",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "ƏTRAFLI ÖYRƏN",
        "UiKit_Fill_Min_Length_Field_Label": "Bu sahə ən azı {{minLength}} simvoldan ibarət olmalıdır.",
        "UiKit_Fill_Out_Field_Label": "Bu sahə doldurulmalıdır.",
        "Support": "Dəstək",
        "Support_WhatsApp_Text": "WhatsApp Canlı Dəstək Xətti vasitəsilə bizimlə əlaqə saxlaya bilərsiniz:",
        "Support_WhatsApp_Button": "WhatsApp Dəstək Xətti"
    },
    "kk": {
        "Back_To_Dashboard": "Басқару тақтасына оралу",
        "Back_To_Products": "Өнімдерге оралу",
        "Profile_Settings": "Профиль параметрлері",
        "GoTo_Product": "Өнімге өту",
        "Start_Trial": "Сынақ мерзімін бастау",
        "Learn": "Үйрену",
        "Reports": "Есептер",
        "Status": "Күй",
        "Free_Simpra_Account": "Тегін Simpra тіркелгіңізбен бастайық",
        "Name": "Аты",
        "Surname": "Тегі",
        "Email": "Электрондық пошта",
        "Phone_Code": "Ел коды",
        "Phone_Number": "Телефон нөмірі",
        "Current_Password": "Ағымдағы құпия сөз",
        "New_Password": "Жаңа құпия сөз",
        "Confirm_New_Password": "Жаңа құпия сөзді растаңыз",
        "Your_Account": "Тіркелгіңізбен жұмысыңыз аяқталды ма?",
        "Meet_Our_Products": "Басқа Simpra өнімдерін қолданып көріңіз",
        "Meet_Our_Products_Description": "Бизнесіңіздің барлық қажеттіліктеріне арналған қосымша шешімдерді ашыңыз.",
        "New_Customer_Meet_Our_Products": "Simpra өнімдерін қолданып көріңіз",
        "New_Customer_Meet_Our_Products_Description": "Бизнесіңіздің барлық қажеттіліктерін қанағаттандыруға арналған шешімдерімізді ашып, айырмашылықты сезініңіз.",
        "Sign_Out_From_Browser": "Осы браузерден шығу",
        "Welcome": "Қош келдіңіз",
        "Sign_Out": "Шығу",
        "My_Permissions": "Менің рұқсаттарым",
        "Campaign_Notifications": "Науқан хабарландырулары",
        "Campaign_Notifications_Question": "Барлық науқандар мен хабарландырулар туралы хабардар болғыңыз келе ме?",
        "Email_Permission": "Иә, электрондық пошта арқылы хабардар болғым келеді.",
        "SMS_Permission": "Иә, SMS арқылы хабардар болғым келеді.",
        "Phone_Permission": "Иә, қоңырау арқылы хабардар болғым келеді.",
        "Close": "ЖАБУ",
        "POS_App_Only_Title": "Қолданбамыздан жалғастырыңыз",
        "POS_App_Only_Message": "Simpra POS пайдалану үшін, iOS, Android мобильді қолданбаларымыздан немесе Windows, MacOS, Linux жұмыс үстелі қолданбаларымыздан жалғастырыңыз.",
        "Product_Inactive_Message": "Бұл өнімге кіруіңіз қазір белсенді емес. Әкімшіңізге хабарласыңыз.",
        "Chatbot_Button_Label": "СӘЛЕМ!",
        "Recommended_For_Device": "Құрылғыңызға ұсынылады",
        "Other_Platforms": "Басқа платформалар",
        "Status_Operational": "Жұмыс істеп тұр",
        "Status_Degraded": "Ішінара іркіліс",
        "Status_Down": "Істемей тұр",
        "Save": "САҚТАУ",
        "Your_Products": "Сіздің өнімдеріңіз",
        "Your_Product_Message": "Бизнесіңіздің барлық қажеттіліктерін қанағаттандыруға арналған шешімдер.",
        "All_Other_Products": "Барлық басқа өнімдер",
        "passwordRulesMessage": "Құпия сөзіңіз мыналарды қамтуы керек:",
        "passwordRules1": "Кемінде 8 таңба",
        "passwordRules2": "Кемінде 1 сан",
        "passwordRules3": "Кемінде 1 бас әріп",
        "passwordRules4": "Кемінде 1 арнайы таңба",
        "Learn_More": "Толығырақ білу",
        "Verified": "РАСТАЛДЫ",
        "Not_Verified": "РАСТАЛМАДЫ",
        "Change_My_Password": "Құпия сөзімді өзгерту",
        "Change_My_Password_Content": "Құпия сөзіңізді өзгерту үшін жүйеден шығып, кіру бетіндегі “Құпия сөзді ұмыттыңыз ба” өрісін пайдалана аласыз.",
        "Enter_Your_Name": "Атыңызды енгізіңіз",
        "Enter_Your_Surname": "Тегіңізді енгізіңіз",
        "Enter_Your_Phone": "Телефоныңызды енгізіңіз",
        "Chatbot_Welcome_Text": "Сәлем {{username}}! Таңдаған Simpra өнімі туралы кез келген сұрақ қойыңыз, мен жауап табамын.",
        "Chatbot_First_Message": "Әрине, Simpra Inventory өнімі туралы сұрағыңызды қойыңыз.",
        "Chatbot_Ask_About_Products": "Өнімдеріміз туралы сұраңыз.",
        "Chatbot_Chat_Rating_Question": "Simpra AI-мен әңгімеңіз қалай өтіп жатыр?",
        "Chatbot_End_Chat": "ӘҢГІМЕНІ АЯҚТАУ",
        "Chatbot_Send": "ЖІБЕРУ",
        "Chatbot_Thank_You": "Рахмет",
        "Chatbot_Feedback_Text": "Simpra AI құрметті клиенттеріміздің пікірлерін жақсарту үшін үнемі жұмыс істейді.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Қай өнім туралы сұрағыңыз бар?",
        "Chatbot_Hello": "СӘЛЕМ",
        "Chatbot_Hello_Text": "Сәлем {{username}}. Мен Simpra AI-мын",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Simpra Reservation арқылы барлық брондарыңызды уақыт пен орын шектеуінсіз бір жерде жинаңыз. Басқару енді әлдеқайда оңай!",
        "sliderText2": "Жылжымалы Орташа Өлшенген Өзіндік құн есебі арқылы өзгермелі экономикалық жағдайларда нақты шығындарыңызды нақты уақытта көріп, табыстылығыңызды сақтаңыз.",
        "sliderText3": "Операцияларыңызды кез келген жерден нақты уақытта қадағалаңыз, дұрыс сату стратегияларын жасаңыз және кірісіңізді 15%-ға дейін арттырыңыз.",
        "sliderText4": "Мәзіріңіз әрдайым жаңартылған және экологиялық таза! Order & Pay плагині арқылы байланыссыз тапсырыс беру мен төлеудің қолайлылығын сезініңіз.",
        "sliderTextHeaderBadge1": "Тоқтатыңыз!",
        "sliderTextHeaderBadge2": "Динамикалық өзіндік құнды басқару",
        "sliderTextHeaderBadge3": "Телефоныңыздан үйреніңіз!",
        "sliderTextHeaderBadge4": "Мүлдем тегін!",
        "sliderTextHeader1": "Келмей қалу алаңдаушылығы",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Мейрамханаңыздың күйі",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "ТОЛЫҒЫРАҚ БІЛУ",
        "UiKit_Fill_Min_Length_Field_Label": "Бұл өріс кемінде {{minLength}} таңбадан тұруы керек.",
        "UiKit_Fill_Out_Field_Label": "Бұл өрісті толтыру керек.",
        "Support": "Қолдау",
        "Support_WhatsApp_Text": "Бізге WhatsApp тікелей қолдау желісі арқылы хабарласа аласыз:",
        "Support_WhatsApp_Button": "WhatsApp қолдау желісі"
    },
    "is": {
        "Back_To_Dashboard": "Til baka á stjórnborð",
        "Back_To_Products": "Til baka í vörur",
        "Profile_Settings": "Notandastillingar",
        "GoTo_Product": "Fara í vöru",
        "Start_Trial": "Hefja prufuáskrift",
        "Learn": "Læra",
        "Reports": "Skýrslur",
        "Status": "Staða",
        "Free_Simpra_Account": "Byrjum með ókeypis Simpra reikningnum þínum",
        "Name": "Nafn",
        "Surname": "Eftirnafn",
        "Email": "Netfang",
        "Phone_Code": "Landsnúmer",
        "Phone_Number": "Símanúmer",
        "Current_Password": "Núverandi lykilorð",
        "New_Password": "Nýtt lykilorð",
        "Confirm_New_Password": "Staðfestu nýtt lykilorð",
        "Your_Account": "Ertu búin(n) með reikninginn þinn?",
        "Meet_Our_Products": "Prófaðu aðrar Simpra vörur",
        "Meet_Our_Products_Description": "Uppgötvaðu fleiri lausnir sniðnar að öllum þörfum fyrirtækisins þíns.",
        "New_Customer_Meet_Our_Products": "Prófaðu Simpra vörur",
        "New_Customer_Meet_Our_Products_Description": "Uppgötvaðu lausnirnar okkar sem eru hannaðar til að mæta öllum þörfum fyrirtækisins þíns og upplifðu muninn.",
        "Sign_Out_From_Browser": "Skrá út úr þessum vafra",
        "Welcome": "Velkomin(n)",
        "Sign_Out": "Útskráning",
        "My_Permissions": "Heimildir mínar",
        "Campaign_Notifications": "Tilkynningar um herferðir",
        "Campaign_Notifications_Question": "Viltu fá upplýsingar um allar herferðir og tilkynningar?",
        "Email_Permission": "Já, ég vil fá tilkynningar með tölvupósti.",
        "SMS_Permission": "Já, ég vil fá upplýsingar með SMS.",
        "Phone_Permission": "Já, ég vil fá tilkynningar með símtali.",
        "Close": "LOKA",
        "POS_App_Only_Title": "Haltu áfram úr appinu okkar",
        "POS_App_Only_Message": "Til að nota Simpra POS, haltu áfram úr iOS, Android farsímaöppunum okkar eða Windows, MacOS, Linux skjáborðsöppunum okkar.",
        "Product_Inactive_Message": "Aðgangur þinn að þessari vöru er ekki virkur núna. Vinsamlegast hafðu samband við kerfisstjóra.",
        "Chatbot_Button_Label": "HÆ!",
        "Recommended_For_Device": "Mælt með fyrir tækið þitt",
        "Other_Platforms": "Aðrir vettvangar",
        "Status_Operational": "Í rekstri",
        "Status_Degraded": "Hluta bilun",
        "Status_Down": "Óvirkt",
        "Save": "VISTA",
        "Your_Products": "Vörurnar þínar",
        "Your_Product_Message": "Lausnir hannaðar til að mæta öllum þörfum fyrirtækisins þíns.",
        "All_Other_Products": "Allar aðrar vörur",
        "passwordRulesMessage": "Lykilorðið þitt verður að innihalda:",
        "passwordRules1": "Að minnsta kosti 8 stafi",
        "passwordRules2": "Að minnsta kosti 1 tölustaf",
        "passwordRules3": "Að minnsta kosti 1 hástaf",
        "passwordRules4": "Að minnsta kosti 1 sérstaf",
        "Learn_More": "Læra meira",
        "Verified": "STAÐFEST",
        "Not_Verified": "EKKI STAÐFEST",
        "Change_My_Password": "Breyta lykilorðinu mínu",
        "Change_My_Password_Content": "Til að breyta lykilorðinu þínu geturðu skráð þig út og notað “Gleymt lykilorð” reitinn á innskráningarsíðunni.",
        "Enter_Your_Name": "Sláðu inn nafnið þitt",
        "Enter_Your_Surname": "Sláðu inn eftirnafnið þitt",
        "Enter_Your_Phone": "Sláðu inn símann þinn",
        "Chatbot_Welcome_Text": "Halló {{username}}! Spurðu mig um hvaða Simpra vöru sem þú vilt og ég finn svar.",
        "Chatbot_First_Message": "Að sjálfsögðu, spurðu spurningarinnar þinnar um Simpra Inventory vöruna.",
        "Chatbot_Ask_About_Products": "Spurðu mig um vörurnar okkar.",
        "Chatbot_Chat_Rating_Question": "Hvernig gengur samtalið þitt við Simpra AI?",
        "Chatbot_End_Chat": "LJÚKA SAMTALI",
        "Chatbot_Send": "SENDA",
        "Chatbot_Thank_You": "Takk fyrir",
        "Chatbot_Feedback_Text": "Simpra AI vinnur stöðugt að því að bæta endurgjöf frá dýrmætu viðskiptavinum okkar.",
        "Chatbot_Simpra_AI": "Simpra AI",
        "Chatbot_Product_Selection_Question": "Um hvaða vöru ertu með spurningu?",
        "Chatbot_Hello": "HALLÓ",
        "Chatbot_Hello_Text": "Hæ {{username}}. Ég er Simpra AI",
        "Simpra_Reports": "Simpra Reports",
        "sliderText1": "Með Simpra Reservation safnarðu öllum bókunum þínum á einn stað án tíma- eða staðsetningartakmarkana. Stjórnun er nú miklu auðveldari!",
        "sliderText2": "Með útreikningi á hlaupandi vegnu meðalkostnaði sérðu raunverulegan kostnað þinn í rauntíma við breytilegar efnahagsaðstæður og viðheldur arðsemi þinni.",
        "sliderText3": "Fylgstu með rekstrinum þínum í rauntíma hvaðan sem er, þróaðu réttar sölustefnur og auktu tekjur þínar um allt að 15%.",
        "sliderText4": "Matseðillinn þinn er alltaf uppfærður og umhverfisvænn! Njóttu þægindanna við snertilausa pöntun og greiðslu með Order & Pay viðbótinni.",
        "sliderTextHeaderBadge1": "Bindum enda á það!",
        "sliderTextHeaderBadge2": "Kraftmikil kostnaðarstjórnun",
        "sliderTextHeaderBadge3": "Lærðu úr símanum þínum!",
        "sliderTextHeaderBadge4": "Alveg ókeypis!",
        "sliderTextHeader1": "Áhyggjur af ómættum bókunum",
        "sliderTextHeader2": "Simpra Inventory",
        "sliderTextHeader3": "Staða veitingastaðarins þíns",
        "sliderTextHeader4": "Simpra QR Menu",
        "learnMore": "LÆRA MEIRA",
        "UiKit_Fill_Min_Length_Field_Label": "Þessi reitur verður að vera að minnsta kosti {{minLength}} stafir.",
        "UiKit_Fill_Out_Field_Label": "Það verður að fylla út þennan reit.",
        "Support": "Aðstoð",
        "Support_WhatsApp_Text": "Þú getur haft samband við okkur í gegnum WhatsApp beina þjónustulínu:",
        "Support_WhatsApp_Button": "WhatsApp þjónustulína"
    },
}
